<template>
	<vs-popup
		class="popup-container"
		:active.sync="popupActive"
		fullscreen
		title="Tous les backlinks"
	>
		<!-- ✅ NOUVEAU : Popup de confirmation pour changement de statut -->
		<!-- <vs-popup
			class="status-change-popup"
			:active.sync="statusChangePopupActive"
			style="z-index: 100000 !important"
			title="Confirmation de changement de statut"
		>
			<div class="popup-content">
				<div class="warning-icon">
					<i
						class="feather icon-alert-triangle"
						style="font-size: 48px; color: #ff9800"
					></i> 
				</div>

				<h3>Le statut va passer à inactif</h3>

				<p>Voulez-vous supprimer l'achat associé à ce backlink ?</p>

				<div class="popup-actions">
					<vs-button color="success" @click="confirmStatusChange(true)">
						Oui, supprimer l'achat
					</vs-button>

					<vs-button color="primary" @click="confirmStatusChange(false)">
						Non, conserver l'achat
					</vs-button>

					<vs-button color="danger" @click="cancelStatusChange()">
						Annuler
					</vs-button>
				</div>
			</div>
		</vs-popup> -->
		<vs-popup
			class="status-change-popup"
			:active.sync="duplicationConfirmationPopup"
			style="z-index: 100000 !important"
			title="Confirmation des doublons détectés"
		>
			<div class="popup-content">
				<div class="warning-icon">
					<i
						class="feather icon-alert-triangle"
						style="font-size: 48px; color: #ff9800"
					></i>
				</div>

				<h3>Des doublons ont été détectés</h3>
				<p>Les netlinks suivants existent déjà dans la base de données :</p>

				<vs-table
					stripe
					:data="matchingUrls"
					id="tb"
					class="mt-5"
					noDataText="Aucun doublon trouvé"
				>
					<template slot="thead">
						<vs-th class="th-sticky" style="pointer-events: auto">Client</vs-th>
						<vs-th class="th-sticky" style="pointer-events: auto"
							>Contrat</vs-th
						>
						<vs-th class="th-sticky" style="pointer-events: auto"
							>Prestation</vs-th
						>
						<vs-th class="th-sticky" style="pointer-events: auto"
							>Url Backlinks</vs-th
						>
						<vs-th class="th-sticky" style="pointer-events: auto"
							>Landing Page</vs-th
						>
						<vs-th class="th-sticky" style="pointer-events: auto"
							>Periode</vs-th
						>
					</template>

					<template slot-scope="{ data }">
						<vs-tr :key="index" v-for="(item, index) in data">
							<vs-td :data="item.society_id">
								{{ getSocietyName(societies, item.society_id) }}
							</vs-td>
							<vs-td :data="item.contract_id">
								{{ item.contract_id }}
							</vs-td>
							<vs-td :data="item.mission_id">
								{{ getMissionName(missions, item.mission_id) }}
							</vs-td>
							<vs-td :data="item.url_bought">
								{{ item.url_bought }}
							</vs-td>
							<vs-td :data="item.landing_page">
								{{ item.landing_page }}
							</vs-td>
							<vs-td :data="item.period_date">
								{{ item.period_date }}
							</vs-td>
						</vs-tr>
					</template>
				</vs-table>

				<div class="popup-actions">
					<vs-button
						color="primary"
						@click="duplicationConfirmationPopup = false"
						:disabled="isSaving"
					>
						Modifier
					</vs-button>
					<vs-button
						color="success"
						@click="saveAllChanges()"
						:disabled="isSaving"
					>
						<span v-if="!isSaving">Continuer (Mettre à jour les doublons)</span>
						<span v-else style="display: flex; align-items: center; gap: 8px">
							<CircularLoader :size="20" />
							<span>Enregistrement...</span>
						</span>
					</vs-button>
				</div>
			</div>
		</vs-popup>

		<!-- Main Popup Content -->
		<div style="height: 100%">
			<div class="example-wrapper">
				<!-- Add Filter Section -->
				<div class="filter-section">
					<h4>Filtres</h4>
					<div class="flex gap-4 mb-4">
						<div class="w-1/7">
							<label>URL Backlink</label>
							<vs-input
								type="text"
								v-model="queries.url_link"
								placeholder="Filtrer par URL"
								@input="applyFilters"
							/>
						</div>
						<div class="w-1/7">
							<label>N°Contrat</label>
							<vs-input
								type="text"
								v-model="queries.contract_id"
								placeholder="Filtrer par N° de contrat"
								@input="applyFilters"
							/>
						</div>
						<div class="w-1/7">
							<label>Statut</label>
							<vs-select
								autocomplete
								multiple
								v-model="queries.status"
								class="w-full select-medium"
								placeholder="Statut"
								@change="applyFilters"
							>
								<vs-select-item
									:key="index"
									:value="item.status_value"
									:text="item.status_text"
									v-for="(item, index) in netlinkStatus"
									class="w-full"
								/>
							</vs-select>
						</div>

						<div class="w-1/7">
							<label>Client</label>
							<vs-select
								autocomplete
								v-model="queries.society_id"
								class="w-full select-medium"
								placeholder="Client"
								@change="applyFilters"
							>
								<vs-select-item value="" text="Tous" class="w-full" />
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item, index) in societies"
									class="w-full"
								/>
							</vs-select>
						</div>
						<div class="w-1/7">
							<label>Prestataire</label>
							<vs-select
								autocomplete
								v-model="queries.provider_id"
								class="w-full select-medium"
								placeholder="Type lien"
								@change="applyFilters"
							>
								<vs-select-item value="" text="Tous" class="w-full" />
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.society"
									v-for="(item, index) in providers"
									class="w-full"
								/>
							</vs-select>
						</div>

						<div class="w-1/7">
							<label>Consultant</label>
							<vs-select
								autocomplete
								v-model="queries.consultant_id"
								class="w-full select-medium"
								placeholder="consultant"
								@change="applyFilters"
							>
								<vs-select-item value="" text="Tous" class="w-full" />
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.firstname + ' ' + item.lastname"
									v-for="(item, index) in consultants"
									class="w-full"
								/>
							</vs-select>
						</div>
						<div class="w-1/7">
							<label>Type d'ancre</label>
							<vs-select
								autocomplete
								v-model="queries.anchor_type"
								class="w-full select-medium"
								placeholder="Type lien"
								@change="applyFilters"
							>
								<vs-select-item value="" text="Tous" class="w-full" />
								<vs-select-item
									:key="index"
									:value="item.type_value"
									:text="item.type_text"
									v-for="(item, index) in filterOptionAnchorTypes"
									class="w-full"
								/>
							</vs-select>
						</div>
						<div class="w-1/7">
							<label>Type de lien</label>
							<vs-select
								autocomplete
								v-model="queries.link_type"
								class="w-full select-medium"
								placeholder="Type lien"
								@change="applyFilters"
							>
								<vs-select-item value="" text="Tous" class="w-full" />
								<vs-select-item
									:key="index"
									:value="item.id"
									:text="item.name"
									v-for="(item, index) in linkTypes"
									class="w-full"
								/>
							</vs-select>
						</div>
						<div class="w-1/7">
							<label>Etat du lien</label>
							<vs-select
								autocomplete
								multiple
								v-model="queries.additional_link_type"
								class="w-full select-medium"
								placeholder="Status"
								@change="applyFilters"
							>
								<vs-select-item
									:key="index"
									:value="item.value"
									:text="item.text"
									v-for="(item, index) in additionalLinkTypes"
									class="w-full"
								/>
							</vs-select>
						</div>
					</div>
					<div class="flex">
						<div class="filter-item w-1/7">
							<label>Période de début</label>
							<div class="flex">
								<vx-input-group class="w-full bottom">
									<template slot="prepend">
										<div class="prepend-text bg-primary">
											<span class="flex"
												><vs-icon icon="calendar_today" size="small"></vs-icon
											></span>
										</div>
									</template>
									<div :key="datePickerKey">
										<month-picker-input
											:max-date="maxDate"
											:default-year="thisYear"
											:default-month="thisMonth"
											:no-default="true"
											lang="fr"
											@input="onPeriodDateChange"
											placeholder="Début"
										/>
									</div>
								</vx-input-group>
								<div
									style="
										margin-left: -85px;
										margin-top: 8px;
										cursor: pointer;
										z-index: 999;
									"
									v-if="queries.period"
									@click="clearPeriodDate"
									title="Effacer la période de début"
								>
									X
								</div>
							</div>
						</div>
						<div class="filter-item w-1/7">
							<label>Période de fin</label>
							<div class="flex">
								<vx-input-group class="w-full bottom">
									<template slot="prepend">
										<div class="prepend-text bg-primary">
											<span class="flex"
												><vs-icon icon="calendar_today" size="small"></vs-icon
											></span>
										</div>
									</template>
									<div :key="endDatePickerKey">
										<month-picker-input
											:max-date="maxDate"
											:min-date="endPeriodMinDate"
											:default-year="endThisYear"
											:default-month="endThisMonth"
											:no-default="true"
											:disabled="isEndPeriodDisabled"
											lang="fr"
											@input="onEndPeriodDateChange"
											placeholder="Fin"
										/>
									</div>
								</vx-input-group>
								<div
									style="
										margin-left: -85px;
										margin-top: 8px;
										cursor: pointer;
										z-index: 999;
									"
									v-if="queries.end_period_date"
									@click="clearEndPeriodDate"
									title="Effacer la période de fin"
								>
									X
								</div>
							</div>
						</div>
						<div class="filter-row mt-2">
							<div class="flex-row">
								<!-- <vs-button
									class="action-button"
									color="primary"
									@click="applyFilters"
								>
									Recherche
								</vs-button> -->
								<vs-button
									class="action-button"
									color="danger"
									@click="resetFilters"
								>
									Réinitialiser
								</vs-button>
							</div>
						</div>
					</div>
				</div>
				<!-- End Filter Section -->

				<!-- Filter pending indicator -->
				<!-- <div v-if="isFilterPending" class="filter-pending-indicator">
					<vs-icon icon="update" class="spin-animation"></vs-icon>
					<span style="margin-left: 8px;">Application des filtres en cours...</span>
				</div> -->

				<div
					class="mt-5 mb-3"
					style="
						margin-bottom: 5px;
						display: flex;
						justify-content: space-between;
					"
				>
					<div class="flex">
						<vs-button
							class="action-button"
							color="primary"
							icon-pack="feather"
							icon="icon-plus"
							@click="onBtAddRow"
						>
							Ajouter
						</vs-button>
						<vs-button
							ref="import-netlink-button"
							icon-pack="feather"
							icon="icon-upload-cloud"
							color="dark"
							@click="goToImportNetlinkPage()"
							>Importer des netlinks
						</vs-button>
						<!-- 🔹 NEW: Export button -->
						<vs-button
							ref="export-netlink-button"
							icon-pack="feather"
							icon="icon-download-cloud"
							color="success"
							@click="exportNetlinks()"
							:disabled="isExporting"
						>
							{{ isExporting ? "Export en cours..." : "Exporter des netlinks" }}
						</vs-button>
					</div>
					<div style="display: flex; align-items: center; gap: 10px">
						<!-- Price summation display -->
						<div
							v-if="selectedRowsData.length > 0"
							class="price-totals"
							style="display: inline-flex !important"
						>
							<span class="total-item">
								<strong>Total PA:</strong>
								{{ convertInternationalNumberToFrenchCurrency(totalBuyPrice) }}
							</span>
							<span class="divider">|</span>
							<span class="total-item">
								<strong>Total PV:</strong>
								{{ convertInternationalNumberToFrenchCurrency(totalSellPrice) }}
							</span>
							<span class="divider">|</span>
							<span class="total-item">
								<strong>Tx Marge:</strong>
								{{ marginRate }}%
							</span>
							<span class="divider">|</span>
							<span class="total-item">
								<strong>Sélectionnés:</strong> {{ selectedRows.size }}
							</span>
						</div>
						<vs-button
							v-if="!isSaving"
							class="action-button"
							color="success"
							icon-pack="feather"
							icon="icon-save"
							@click="confirmSaveChanges()"
							:disabled="isSaving"
						>
							<span>Enregistrer</span>
						</vs-button>
						<div v-else>
							<CircularLoader />
						</div>
					</div>
				</div>
				<!-- Remove the debug display of isLoading -->
				<div v-if="isLoading || isFilterPending" class="loader-container">
					<circular-loader></circular-loader>
				</div>
				<ag-grid-vue
					v-else
					:key="tableKey"
					style="width: 100%; height: 730px"
					class="ag-theme-balham mt-5"
					@grid-ready="onGridReady"
					:rowHeight="40"
					:columnDefs="columnDefs"
					:defaultColDef="defaultColDef"
					:editType="editType"
					:rowData="netlinks"
					@cell-value-changed="onCellValueChanged"
					@row-value-changed="onRowValueChanged"
					:rowSelection="'multiple'"
					@selection-changed="onSelectionChanged"
					:tooltipShowDelay="100"
					:tooltipHideDelay="10000"
					:getRowStyle="getRowStyle"
				></ag-grid-vue>
				<vs-pagination
					:total="paginationTotal"
					v-model="currentx"
				></vs-pagination>
			</div>
		</div>
	</vs-popup>
</template>

<script>
import VueCookies from "vue-cookies";
import { AgGridVue } from "ag-grid-vue";
import NumericCellEditor from "../widgets/ag-grid/NumericCellEditor.vue";
import PeriodCellEditor from "../widgets/ag-grid/PeriodCellEditor.vue";
import Netlink from "../../entities/Netlink";
import Provider from "../../entities/Provider";
import PeriodPicker from "../widgets/PeriodPicker.vue";
import store from "@/store/store";
import CircularLoader from "../widgets/loader/CircularLoader.vue";
import Mission from "../../entities/Mission";
import backlinksMixins from "../../mixins/backlinksMixins";
import dbFieldConvertorMixin from "../../mixins/dbFieldConvertorMixin";
import { MonthPickerInput } from "vue-month-picker";
import moment from "moment";
import { parseInt } from "core-js/fn/number";

export default {
	name: "AllBacklinksPopupup",
	components: {
		AgGridVue,
		NumericCellEditor,
		PeriodCellEditor,
		PeriodPicker,
		CircularLoader,
		MonthPickerInput,
	},
	props: {
		popupActive: {
			type: Boolean,
			default: false,
		},
		contractId: {
			type: Number,
			default: null,
		},
		societyName: {
			type: String,
			default: "",
		},
	},
	mixins: [backlinksMixins, dbFieldConvertorMixin],
	data() {
		return {
			isLoading: false,
			isFilterPending: false,
			isSaving: false,
			netlinks: [],
			originalNetlinks: {},
			queries: {
				contract_id: null,
				consultant_id: null, // Assuming you want to filter by consultant
				society_name: null,
				url_bought: null,
				anchor_type: null,
				link_type: null,
				landing_page: null,
				provider_id: null,
				period: `${moment().format("MM/YYYY")}`, // Default to current month/year
				end_period_date: "", // End period for range selection
				society_id: null,
				status: [], // Multiple status selection
				url_link: null, // URL filter field
				additional_link_type: [], // dofollow/nofollow/unknown filter
			},
			missions: [],
			consultants: [], // Assuming you have a list of consultants
			// ✅ NOUVEAU : Propriétés pour le month picker
			useGestionPeriodPicker: true, // Set to true to use month picker, false for select dropdown
			datePickerKey: 0,
			thisMonth: parseInt(moment().format("MM")),
			thisYear: parseInt(moment().format("YYYY")),
			maxDate: new Date(moment().format("YYYY-MM-DD")),
			// End period picker properties
			endDatePickerKey: 0,
			endThisMonth: null,
			endThisYear: null,
			// Store grid API reference
			paginationTotal: 0,
			currentx: 1,
			gridApi: null,
			// Listes pour les dropdowns
			themas: [],
			providers: [],
			linkTypes: [],
			anchorTypes: [],
			filterOptionAnchorTypes: [],
			periodList: [],
			renewDurations: [
				{ id: 0, label: "A vie" },
				{ id: 1, label: "Mensuel" },
				{ id: 12, label: "Annuel" },
			],
			facturableOptions: [
				{ id: 0, label: "Non" },
				{ id: 1, label: "Oui" },
			],
			internationalOptions: [
				{ id: 0, label: "Non" },
				{ id: 1, label: "Oui" },
			],
			netlinkStatus: [
				{ status_value: 0, status_text: "Actif" },
				{ status_value: 1, status_text: "En\u00a0attente" },
				{ status_value: 2, status_text: "Refusé" },
				{ status_value: 3, status_text: "Terminé" },
				{ status_value: 6, status_text: "Litige" },
			],
			additionalLinkTypes: [
				{ value: "dofollow", text: "Dofollow" },
				{ value: "nofollow", text: "Nofollow" },
				{ value: "unknown", text: "Unknown" },
			],

			tableKey: 0,
			// Track changes
			modifiedRows: new Set(),
			newRows: new Set(),
			deletedRows: new Set(),
			// Column definitions
			columnDefs: [],
			// Debounce timer for filtering
			filterTimeout: null,

			defaultColDef: {
				flex: 1,
				editable: true,
				cellDataType: false,
				resizable: true,
				sortable: true,
				tooltipShowDelay: 200, // Show tooltip after 200ms (0.2 seconds)
			},

			// Edit type (null disables full row editing)
			editType: null,

			// ✅ NOUVEAU : Propriétés pour la popup de changement de statut
			statusChangePopupActive: false,
			currentStatusChangeEvent: null,
			statusChangeResolver: null,
			// Duplication
			duplicationConfirmationPopup: false,
			matchingUrls: [],
			nonMatchingUrls: [],

			isExporting: false, // 🔹 NEW: Track export state
			// Checkbox selection tracking
			selectedRows: new Set(),
			selectedRowsData: [],
		};
	},
	computed: {
		hasChanges() {
			return (
				this.modifiedRows.size > 0 ||
				this.newRows.size > 0 ||
				this.deletedRows.size > 0
			);
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		societies() {
			return store.state.societies;
		},
		totalBuyPrice() {
			let total = 0;
			this.selectedRowsData.forEach((row) => {
				if (row.price) {
					total += parseFloat(row.price);
				}
			});
			return total.toFixed(2);
		},
		totalSellPrice() {
			let total = 0;
			this.selectedRowsData.forEach((row) => {
				if (row.calculated_price) {
					total += parseFloat(row.calculated_price);
				}
			});
			return total.toFixed(2);
		},
		marginRate() {
			const pv = parseFloat(this.totalSellPrice);
			const pa = parseFloat(this.totalBuyPrice);
			if (pa === 0) return "0.00";
			const margin = ((pv - pa) / pa) * 100;
			return margin.toFixed(2);
		},
		contracts() {
			return store.state.contracts;
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
		existingNetlinks() {
			return store.state.netlink || [];
		},
		// ✅ NOUVEAU : Disable end period picker if no start period is selected
		isEndPeriodDisabled() {
			return !this.queries.period || this.queries.period === "";
		},
		// ✅ NOUVEAU : Set minimum date for end period picker based on start period
		endPeriodMinDate() {
			if (!this.queries.period || this.queries.period === "") {
				return null;
			}
			// Parse the start period date (MM/YYYY format)
			const [month, year] = this.queries.period.split("/").map(Number);
			// Return a Date object for the first day of the selected month
			return new Date(year, month - 1, 1);
		},
	},
	watch: {
		currentx(newVal) {
			if (newVal) {
				this.fetchDatas(false);
			}
		},
	},
	created() {
		// Charger les netlinks au démarrage
		store.dispatch("getAllNetlink");
		this.defaultConsultant();
		this.fetchDatas();
		this.getAllSociety();
		this.getAllContracts();
		this.getPeriodList();
		this.fetchAllCollaborators();
	},
	methods: {
		// Method to style rows based on status
		getRowStyle(params) {
			// Status 2 = Refusé - make the row red
			if (params.data && params.data.status === 2) {
				return {
					backgroundColor: "#ffebee", // Light red background
					color: "#c62828", // Dark red text
				};
			}
			return null;
		},

		// ✅ NOUVEAU : Méthodes pour la gestion des doublons
		getMatchingUrls(newNetlinks, existingNetlinks) {
			const matches = [];

			newNetlinks.forEach((newNetlink) => {
				// Find matching existing netlink based on duplicate criteria (only check against active status = 0)
				const match = existingNetlinks.find((existing) => {
					if (
						!existing.url_bought ||
						!existing.landing_page ||
						!newNetlink.url_bought ||
						!newNetlink.landing_page
					) {
						return false;
					}

					// Only check against active netlinks (status = 0)
					if (existing.status !== 0) {
						return false;
					}

					return (
						existing.url_bought.trim() === newNetlink.url_bought.trim() &&
						existing.landing_page.trim() === newNetlink.landing_page.trim() &&
						existing.contract_id == newNetlink.contract_id &&
						existing.period_date == newNetlink.period_date
					);
				});

				if (match) {
					matches.push({
						...match,
						society_id: match.society_id,
						mission_id: match.mission_id,
						url_bought: match.url_bought,
						landing_page: match.landing_page,
						period_date: match.period_date,
					});
				}
			});

			return matches;
		},

		markDuplicateNetlinks(newNetlinks, existingNetlinks) {
			console.log("Processing netlinks for duplicates...");
			console.log("New netlinks:", newNetlinks.length);
			console.log("Existing netlinks count:", existingNetlinks.length);

			return newNetlinks.map((netlink, index) => {
				console.log("Processing new netlink at index", index, ":", netlink);

				// Debug: Test specific values
				console.log("Looking for match with:", {
					url_bought: netlink.url_bought ? netlink.url_bought.trim() : "",
					landing_page: netlink.landing_page ? netlink.landing_page.trim() : "",
					contract_id: netlink.contract_id,
					period_date: netlink.period_date,
				});

				// Find if this new netlink matches an existing one (only check against active status = 0)
				const existingMatch = existingNetlinks.find((existing) => {
					// Add null/undefined checks to prevent errors
					if (
						!existing.url_bought ||
						!existing.landing_page ||
						!netlink.url_bought ||
						!netlink.landing_page
					) {
						return false;
					}

					// Only check against active netlinks (status = 0)
					if (existing.status !== 0) {
						return false;
					}

					const urlMatch =
						existing.url_bought.trim() === netlink.url_bought.trim();
					const landingMatch =
						existing.landing_page.trim() === netlink.landing_page.trim();
					const contractMatch = existing.contract_id == netlink.contract_id;
					const periodMatch = existing.period_date == netlink.period_date;

					const isMatch =
						urlMatch && landingMatch && contractMatch && periodMatch;

					if (isMatch) {
						console.log("Match details:", {
							urlMatch,
							landingMatch,
							contractMatch,
							periodMatch,
							existing: {
								url: existing.url_bought.trim(),
								landing: existing.landing_page.trim(),
								contract: existing.contract_id,
								period: existing.period_date,
							},
							new: {
								url: netlink.url_bought.trim(),
								landing: netlink.landing_page.trim(),
								contract: netlink.contract_id,
								period: netlink.period_date,
							},
						});
					}

					return isMatch;
				});

				if (existingMatch) {
					console.log("✅ Found duplicate match:", existingMatch);
					return {
						...netlink,
						_isDuplicate: true,
						_existingId: existingMatch.id,
						_isNew: true,
					};
				} else {
					console.log("❌ No duplicate found");
					return {
						...netlink,
						_isDuplicate: false,
					};
				}
			});
		},

		// ✅ Helper methods for display in popup
		getSocietyName(societies, societyId) {
			const society = societies.find((s) => s.id === societyId);
			return society ? society.name : `Société ${societyId}`;
		},

		getMissionName(missions, missionId) {
			const mission = missions.find((m) => m.id === missionId);
			return mission ? mission.perform : `Mission ${missionId}`;
		},

		// ✅ NOUVEAU : Méthode pour confirmer la sauvegarde avec vérification des doublons
		confirmSaveChanges() {
			// Stop any active editing to commit pending changes
			if (this.gridApi) {
				// Get the editing cell before stopping edit
				const editingCells = this.gridApi.getEditingCells();

				// Stop editing to commit changes
				this.gridApi.stopEditing();

				// If there was an editing cell, manually mark that row as modified (by ID)
				if (editingCells && editingCells.length > 0) {
					editingCells.forEach((cell) => {
						const rowNode = this.gridApi.getDisplayedRowAtIndex(cell.rowIndex);
						if (rowNode && !rowNode.data._isNew && rowNode.data.id) {
							this.modifiedRows.add(rowNode.data.id);
						}
					});
				}
			}

			let newNetlinks = this.netlinks.filter((n) => n._isNew == true);
			this.matchingUrls = this.getMatchingUrls(
				newNetlinks,
				this.existingNetlinks
			);
			console.log("Found matching URLs:", this.matchingUrls);

			// Use the pure function and assign the result
			const markedNetlinks = this.markDuplicateNetlinks(
				newNetlinks,
				this.existingNetlinks
			);

			// Update the original netlinks array with marked duplicates
			this.netlinks = this.netlinks.map((netlink) => {
				if (netlink._isNew) {
					const markedNetlink = markedNetlinks.find(
						(marked) =>
							marked.url_bought === netlink.url_bought &&
							marked.landing_page === netlink.landing_page
					);
					return markedNetlink || netlink;
				}
				return netlink;
			});

			if (this.matchingUrls.length > 0) {
				this.duplicationConfirmationPopup = true;
			} else {
				this.saveAllChanges();
			}
		},

		defaultConsultant() {
			// Set default consultant to current user
			this.queries.consultant_id = this.activeUser.id;
		},
		goToImportNetlinkPage() {
			// this.setLoading(true, "import-netlink-button");
			this.$emit("on-import-netlink");
		},

		// ✅ NOUVEAU : Gestion du month picker (Start Period)
		onPeriodDateChange(date) {
			// Validate that date object exists and has the expected structure
			if (!date || !date.from) {
				console.error(
					"Invalid date object received in onPeriodDateChange:",
					date
				);
				return;
			}

			// Convert month picker date to MM/YYYY format
			let sendDate = moment(date.from).format("MM/YYYY");
			this.queries.period = sendDate;

			console.log("Start period date changed to:", sendDate);

			// ✅ NOUVEAU : Clear end period if it's now before the start period
			if (this.queries.end_period_date) {
				const [startMonth, startYear] = sendDate.split("/").map(Number);
				const [endMonth, endYear] = this.queries.end_period_date
					.split("/")
					.map(Number);

				const startNum = startYear * 100 + startMonth;
				const endNum = endYear * 100 + endMonth;

				if (endNum < startNum) {
					this.queries.end_period_date = "";
					this.endThisMonth = null;
					this.endThisYear = null;
					this.endDatePickerKey++;
					console.log(
						"End period cleared because it was before the new start period"
					);
				}
			}

			// Apply filters with the new date
			this.applyFilters();
		},

		// ✅ NOUVEAU : Clear period date (Start Period)
		clearPeriodDate() {
			this.queries.period = "";
			this.thisMonth = null;
			this.thisYear = null;
			this.datePickerKey++; // Force month picker to reset

			this.applyFilters();
		},

		// ✅ NOUVEAU : Gestion du month picker (End Period)
		onEndPeriodDateChange(date) {
			// Validate that date object exists and has the expected structure
			if (!date || !date.from) {
				console.error(
					"Invalid date object received in onEndPeriodDateChange:",
					date
				);
				return;
			}

			// Convert month picker date to MM/YYYY format
			let sendDate = moment(date.from).format("MM/YYYY");
			this.queries.end_period_date = sendDate;

			console.log("End period date changed to:", sendDate);

			// Apply filters with the new date
			this.applyFilters();
		},

		// ✅ NOUVEAU : Clear end period date
		clearEndPeriodDate() {
			this.queries.end_period_date = "";
			this.endThisMonth = null;
			this.endThisYear = null;
			this.endDatePickerKey++; // Force month picker to reset

			this.applyFilters();
		},

		async handleStatusChange(event) {
			const newStatus = parseInt(event.newValue);
			const oldStatus = parseInt(event.oldValue);
			const rowData = event.data;

			// Get active status value
			const activeStatusValue = this.getActiveStatusValue();

			console.log(
				`Status change: ${oldStatus} -> ${newStatus}, active value: ${activeStatusValue}`
			);

			// Check if status changes TO actif (0) - check for duplicates and propose editing
			if (newStatus === 0 && oldStatus !== 0) {
				// Check for duplicates when changing to actif status
				const isDuplicate = this.checkNetlinkDuplicate({
					...rowData,
					status: newStatus,
				});

				if (isDuplicate) {
					// Find the existing duplicate netlink
					const existingNetlink = this.existingNetlinks.find((existing) => {
						return (
							existing.status === 0 &&
							existing.url_bought &&
							existing.url_bought.trim() === rowData.url_bought.trim() &&
							existing.landing_page &&
							existing.landing_page.trim() === rowData.landing_page.trim() &&
							existing.contract_id == rowData.contract_id &&
							existing.period_date == rowData.period_date
						);
					});

					if (existingNetlink) {
						// Show confirmation to edit existing or create new
						const shouldEditExisting = confirm(
							`Un netlink actif existe déjà avec les mêmes informations:\n\n` +
								`URL: ${existingNetlink.url_bought}\n` +
								`Landing Page: ${existingNetlink.landing_page}\n` +
								`Période: ${existingNetlink.period_date}\n\n` +
								`Voulez-vous modifier le netlink existant au lieu de créer un doublon ?`
						);

						if (shouldEditExisting) {
							// Revert status change
							event.node.setDataValue("status", oldStatus);

							// Show notification
							this.$vs.notify({
								title: "Modification recommandée",
								text: "Veuillez modifier le netlink existant au lieu de créer un doublon.",
								iconPack: "feather",
								icon: "edit",
								color: "primary",
								time: 5000,
							});
							return;
						}
					}
				}
			}

			// Check if status changes from "active" to something else
			if (oldStatus === activeStatusValue && newStatus !== activeStatusValue) {
				try {
					// const shouldRemovePurchase = await this.showStatusChangeConfirmation(
					// 	event
					// );
					const shouldRemovePurchase = false;

					rowData.is_remove_purchase = shouldRemovePurchase;

					// this.$vs.notify({
					// 	title: "Statut modifié",
					// 	text: shouldRemovePurchase
					// 		? "Le statut a été modifié. L'achat sera supprimé lors de l'enregistrement."
					// 		: "Le statut a été modifié. L'achat sera conservé.",
					// 	iconPack: "feather",
					// 	icon: "check-circle",
					// 	color: "primary",
					// });
				} catch (error) {
					console.log("Status change cancelled, reverting...");

					// Revert the status in the data
					rowData.status = oldStatus;

					// Force complete refresh
					this.tableKey++;

					this.$vs.notify({
						title: "Annulation",
						text: "Le changement de statut a été annulé",
						iconPack: "feather",
						icon: "x-circle",
						color: "warning",
					});
					return;
				}
			} else {
				rowData.is_remove_purchase = false;

				// this.$vs.notify({
				// 	title: "Statut modifié",
				// 	text: "Le statut a été modifié avec succès",
				// 	iconPack: "feather",
				// 	icon: "check-circle",
				// 	color: "success",
				// });
			}

			// ✅ GUARANTEED FIX: Force complete component refresh
			// This will re-render the entire grid with updated editable states
			this.tableKey++;
		},

		// ✅ VERIFY: Make sure this method returns 0 for "Actif"
		getActiveStatusValue() {
			// Method 1: Look for "Actif" status
			const activeStatus = this.netlinkStatus.find(
				(status) =>
					status.status_text &&
					(status.status_text.toLowerCase().includes("actif") ||
						status.status_text.toLowerCase().includes("active"))
			);

			if (activeStatus) {
				console.log("Found active status:", activeStatus);
				return parseInt(activeStatus.status_value);
			}

			// Method 2: Default to 0 if not found
			console.log("Active status not found, defaulting to 0");
			return 0;
		},

		// ✅ SIMPLIFIED: Cleaner isRowEditable method
		isRowEditable(params) {
			// Always allow editing for new rows
			if (params.data && params.data._isNew) {
				return true;
			}

			// Super Administrateur (user_type 191) can edit all rows
			if (this.activeUser && this.activeUser.type == 9) {
				return true;
			}

			// Check status: 0 = Actif (not editable for non-super admin), anything else = editable
			if (params.data && params.data.status !== undefined) {
				// Convert to number to be safe
				const status = parseInt(params.data.status);
				return status !== 0; // Not editable only if status is exactly 0
			}

			// Default to editable
			return true;
		},
		forceRowRefresh(rowNode) {
			if (this.gridApi && rowNode) {
				// Method 1: Redraw the entire row (this re-evaluates all column properties)
				this.gridApi.redrawRows({ rowNodes: [rowNode] });

				// Method 2: Alternative approach - refresh all cells with column refresh
				// this.gridApi.refreshCells({
				// 	rowNodes: [rowNode],
				// 	force: true,
				// 	suppressFlash: true
				// });

				// Method 3: Force grid to re-evaluate column definitions (if needed)
				// setTimeout(() => {
				// 	this.gridApi.refreshHeader();
				// }, 100);
			}
		},

		// ✅ NOUVEAU : Afficher la popup de confirmation (version personnalisée)
		showStatusChangeConfirmation(event) {
			return new Promise((resolve, reject) => {
				this.currentStatusChangeEvent = event;
				this.statusChangeResolver = { resolve, reject };
				this.statusChangePopupActive = true;
			});
		},

		// ✅ NOUVEAU : Confirmer le changement de statut
		confirmStatusChange(removePurchase) {
			if (this.statusChangeResolver) {
				this.statusChangeResolver.resolve(removePurchase);
				this.statusChangeResolver = null;
			}
			this.statusChangePopupActive = false;
			this.currentStatusChangeEvent = null;
		},

		// ✅ NOUVEAU : Annuler le changement de statut
		cancelStatusChange() {
			if (this.statusChangeResolver) {
				this.statusChangeResolver.reject(new Error("Cancelled"));
				this.statusChangeResolver = null;
			}
			this.statusChangePopupActive = false;
			this.currentStatusChangeEvent = null;
		},

		// ✅ NOUVEAU : Version simple avec confirm() natif
		showSimpleStatusChangeConfirmation() {
			return new Promise((resolve) => {
				const result = confirm(
					"Le statut va passer à inactif.\n\nVoulez-vous supprimer l'achat associé à ce backlink ?\n\n✅ OK = Supprimer l'achat\n❌ Annuler = Conserver l'achat"
				);
				resolve(result);
			});
		},

		fetchAllCollaborators() {
			// if (this.allCollaborators.length == 0) {
			store.dispatch("getAllCollaborators").then(() => {
				this.getAllConsultants();
			});
			// }
		},
		getAllConsultants() {
			this.consultants = this.allCollaborators.filter((collaborator) =>
				[3, 6, 7, 9].includes(collaborator.type)
			);
			// this.queries.consultant_id = this.activeUser.id; // Set default to current user
		},
		async getPeriodList() {
			// Super admin can access 12 months, regular users get 3 months
			const monthsBack = this.activeUser && this.activeUser.type == 9 ? 12 : 3;
			this.periodList = await this.getPeriodDateList(monthsBack);
		},
		getAllContracts() {
			store.dispatch("getAllContracts");
		},
		getAllSociety() {
			store.dispatch("getAllSocieties");
		},

		// Add new filter methods
		applyFilters() {
			// Clear previous timeout to debounce the filter
			if (this.filterTimeout) {
				clearTimeout(this.filterTimeout);
			}

			// Show pending indicator
			this.isFilterPending = true;

			// Setup debounce for filter to avoid too many API calls
			this.filterTimeout = setTimeout(() => {
				this.isFilterPending = false;
				this.fetchDatas(false);
			}, 1500);
		},

		resetFilters() {
			// Clear any pending filter timeout
			if (this.filterTimeout) {
				clearTimeout(this.filterTimeout);
				this.filterTimeout = null;
			}

			// Clear pending state
			this.isFilterPending = false;

			// Reset all query filters to default
			this.queries = {
				contract_id: null, // Keep contract ID
				society_name: null, // Keep society name
				url_link: null,
				society_id: null,
				anchor_type: null,
				link_type: null,
				landing_page: null,
				provider_id: null,
				period: `${moment().format("MM/YYYY")}`, // Reset to current month/year
				end_period_date: "", // Reset end period
				consultant_id: this.activeUser.id, // Reset to current user
				status: [], // Reset status filter
				additional_link_type: [], // Reset additional link type filter
			};
			this.thisMonth = parseInt(moment().format("MM"));
			this.thisYear = parseInt(moment().format("YYYY"));
			this.endThisMonth = null;
			this.endThisYear = null;

			// Reset month pickers if using them
			if (this.useGestionPeriodPicker) {
				this.datePickerKey++;
				this.endDatePickerKey++;
			}

			// Fetch data with reset filters
			this.fetchDatas(false);
		},

		// ✅ UPDATED: fetchDatas method to preserve sell_price from database
		async fetchDatas(loadAll = true) {
			try {
				// Set contract ID in queries before fetching data
				this.isLoading = true;

				let missionResult,
					netlinksResult,
					providersResult,
					linkTypesResult,
					themasResult,
					statusResult,
					anchorTypesResult;

				// Load all data in parallel
				if (loadAll) {
					[
						missionResult,
						netlinksResult,
						providersResult,
						linkTypesResult,
						themasResult,
						anchorTypesResult,
					] = await Promise.all([
						Mission.getOnlyAllMissionsAsync(),
						Netlink.getFilteredNetlinks(this.queries, this.currentx),
						Provider.getNetlinkProvider(),
						Netlink.getTypes(),
						Netlink.getThemas(),
						Netlink.getNetlinkAnchorTypes(),
					]);
				} else {
					// If loadAll is false, only load netlinks
					netlinksResult = await Netlink.getFilteredNetlinks(
						this.queries,
						this.currentx
					);
				}

				// ✅ NEW: Process netlinks to preserve sell_price from database
				this.netlinks = netlinksResult.data.map((netlink) => {
					// If netlink has sell_price from database, use it as calculated_price
					if (netlink.sell_price !== undefined && netlink.sell_price !== null) {
						netlink.calculated_price = netlink.sell_price;
						// Mark that this price came from database (not calculated)
						netlink.isCalculatedPriceFromDB = true;
					}
					return netlink;
				});

				this.paginationTotal = netlinksResult.pagination.totalPages;

				// Only update these properties if we loaded all data
				if (loadAll) {
					this.missions = missionResult.filter((ele) => {
						return ele.sub_category == 7 || ele.products_id == 136;
					});

					this.providers = providersResult;
					this.linkTypes = linkTypesResult;
					this.themas = themasResult;
					this.anchorTypes = anchorTypesResult;
					this.filterOptionAnchorTypes = anchorTypesResult;
				}

				// Log data for debugging
				console.log("Data loaded:", {
					netlinks: this.netlinks.length,
					providers: this.providers ? this.providers.length : "not loaded",
					linkTypes: this.linkTypes ? this.linkTypes.length : "not loaded",
					netlinkStatus: this.netlinkStatus
						? this.netlinkStatus.length
						: "not loaded",
					anchorTypes: this.anchorTypes
						? this.anchorTypes.length
						: "not loaded",
				});

				// Update original netlinks for change tracking
				this.originalNetlinks = {};
				this.netlinks.forEach((netlink) => {
					if (netlink.id) {
						this.originalNetlinks[netlink.id] = JSON.parse(
							JSON.stringify(netlink)
						);
					}
				});

				// Reset tracking
				this.resetChangeTracking();

				// Ensure we have real data before rendering
				this.assignColumns();
				this.isLoading = false;
				this.isFilterPending = false; // Clear filter pending state
				this.tableKey++; // Force grid refresh
			} catch (error) {
				console.error("Error loading data:", error);
				this.isLoading = false;
				this.isFilterPending = false; // Clear filter pending state
			}
		},

		// ✅ IMPROVED: Enhanced getNonEditableCellStyle method
		getNonEditableCellStyle(params) {
			let style = {};

			// If row is not editable due to status, add visual indication
			if (params.data && !this.isRowEditable(params)) {
				style.backgroundColor = "#f5f5f5";
				style.color = "#999";
				style.cursor = "not-allowed";
				style.opacity = "0.7";
			}

			// Add yellow border for duplicate rows
			if (params.data && params.data._isDuplicate) {
				style.border = "2px solid #FFC107";
				style.backgroundColor = "#FFF9E6";
			}

			return style;
		},

		resetChangeTracking() {
			this.modifiedRows = new Set();
			this.newRows = new Set();
			this.deletedRows = new Set();
		},

		// Updated assignColumns method
		assignColumns() {
			this.columnDefs = [
				{
					headerCheckboxSelection: true,
					checkboxSelection: true,
					headerName: "",
					field: "checkbox",
					width: 50,
					pinned: "left",
					sortable: false,
					filter: false,
					resizable: false,
					suppressMenu: true,
				},
				{
					field: "status",
					headerName: "Statut",
					headerTooltip: "Statut actuel du backlink",
					editable: true, // Status field should always be editable to allow status changes
					pinned: "left",
					cellEditor: "agSelectCellEditor",
					width: 120,
					cellEditorParams: (params) => {
						const value = params.value ? params.value : 0;
						return {
							values: this.netlinkStatus.map((s) => Number(s.status_value)),
							defaultOption: value,
						};
					},
					valueFormatter: (params) => {
						if (params.value === undefined || params.value === null) return "";
						const status = this.netlinkStatus.find(
							(s) => s.status_value == parseInt(params.value)
						);
						return status && status.status_text
							? status.status_text
							: params.value;
					},
					cellStyle: (params) => {
						const colorConfig = this.getNetlinkStatusColor(params.value);
						if (colorConfig) {
							return {
								backgroundColor: colorConfig,
								textAlign: "center",
								color: "#ffffff !important",
								transition: "all 0.2s ease",
							};
						}
						return null;
					},
				},
				{
					field: "additional_online_status",
					headerName: "En ligne",
					headerTooltip: "Statut de mise en ligne du backlink",
					editable: (params) => tfalse,
					width: 100,
					cellRenderer: (params) => {
						if (
							params.value === null ||
							params.value === undefined ||
							params.value === ""
						) {
							return "";
						}
						const status = Number(params.value);
						let color = "";
						let tooltipText = "";
						if (status === 1) {
							color = "#28C76F"; // success green
							tooltipText = "Lien trouvé";
						} else if (status === 4) {
							color = "#FF9F43"; // warning orange
							tooltipText = "Lien vers un autre URL du même domaine";
						} else if (status === 2) {
							color = "#EA5455"; // danger red

							tooltipText = "Lien supprimé (page lue, lien absent)";
						} else if (status === 3) {
							const statusCode =
								params.data && params.data.additional_status_code;
							color = "#979797FF"; // danger red
							tooltipText = "Page illisible, non vérifié"
								+ (statusCode ? " (HTTP " + statusCode + ")" : "");
						}
						const checkedAt = params.data && params.data.additional_updated_date;
						if (checkedAt) {
							tooltipText = tooltipText + " : " + String(checkedAt).split("T")[0];
						}
						return `<div title="${tooltipText}" style="display: flex; align-items: center; justify-content: center; height: 100%; cursor: help;"><svg width="16" height="16" viewBox="0 0 16 16"><circle cx="8" cy="8" r="6" fill="${color}"/></svg></div>`;
					},
					cellStyle: (params) => this.getNonEditableCellStyle(params),
				},
				{
					field: "additional_link_type",
					headerName: "Etat du lien",
					headerTooltip: "Type de lien additionnel",
					editable: (params) => false,
					width: 120,
					cellRenderer: (params) => {
						if (!params.value) return "";
						const value = params.value.toLowerCase();
						let color = "";

						if (value === "dofollow") {
							color = "#28C76F"; // green
						} else if (value === "nofollow") {
							color = "#EA5455"; // red
						} else {
							color = "#B8C2CC"; // gray
						}

						const label = value.charAt(0).toUpperCase() + value.slice(1);
						return `<span style="color: ${color}; font-weight: 500;">${label}</span>`;
					},
					cellStyle: (params) => this.getNonEditableCellStyle(params),
				},

				// ✅ NEW: Make society_id (Client) editable and first in the flow
				{
					field: "society_id",
					headerName: "Client",
					headerTooltip: "Nom du client associé au backlink",
					editable: (params) => this.isRowEditable(params),
					width: 160,
					cellEditor: "agSelectCellEditor",
					cellEditorParams: (params) => {
						const value = params.value ? params.value.toString() : "";
						return {
							values: this.societies.map((p) => p.id.toString()),
							defaultOption: value,
						};
					},
					valueFormatter: (params) => {
						if (!params.value) return "";
						const society = this.societies.find(
							(p) => p.id === parseInt(params.value)
						);
						return society && society.name ? society.name : params.value;
					},
					// Custom comparator to sort by society name instead of society ID
					comparator: (valueA, valueB) => {
						if (!valueA && !valueB) return 0;
						if (!valueA) return -1;
						if (!valueB) return 1;

						// Find society names for both values
						const societyA = this.societies.find(
							(s) => s.id === parseInt(valueA)
						);
						const societyB = this.societies.find(
							(s) => s.id === parseInt(valueB)
						);

						const nameA =
							societyA && societyA.name ? societyA.name.toLowerCase() : "";
						const nameB =
							societyB && societyB.name ? societyB.name.toLowerCase() : "";

						return nameA.localeCompare(nameB);
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						if (params.data._isNew && (!params.value || params.value === "")) {
							style.border = "1px solid red";
						}
						return style;
					},
					valueSetter: (params) => {
						if (params.newValue !== undefined) {
							params.data.society_id = params.newValue;

							// Clear dependent fields when society changes
							params.data.contract_id = null;
							params.data.mission_id = null;
							params.data.manager_id = null;

							// Refresh dependent columns
							if (this.gridApi) {
								setTimeout(() => {
									this.gridApi.refreshCells({
										rowNodes: [params.node],
										columns: ["contract_id", "mission_id", "manager_id"],
										force: true,
									});
								}, 0);
							}
							return true;
						}
						return false;
					},
				},

				// ✅ UPDATED: Filter contract_id based on selected society_id
				{
					field: "contract_id",
					headerName: "N° Contrat",
					headerTooltip: "Numéro du contrat associé",
					editable: (params) => this.isRowEditable(params),
					width: 100,
					cellEditor: "agSelectCellEditor",
					cellEditorParams: (params) => {
						// Filter contracts based on selected society
						const societyId = params.data.society_id;
						let filteredContracts = societyId
							? this.contracts.filter(
									(c) => c.society_id === parseInt(societyId)
							  )
							: [];
						filteredContracts = filteredContracts.sort((a, b) =>
							a.status === 1 && b.status !== 1
								? -1
								: a.status !== 1 && b.status === 1
								? 1
								: a.id - b.id
						);

						const value = params.value ? params.value.toString() : "";
						return {
							values: filteredContracts.map((p) => p.id.toString()),
							defaultOption: value,
						};
					},
					valueFormatter: (params) => {
						if (!params.value) return "";
						const contract = this.contracts.find(
							(p) => p.id === parseInt(params.value)
						);
						return contract && contract.id
							? contract.id + " - " + this.getContractStatus(contract.status)
							: params.value;
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);

						// Red background for empty required fields in new rows
						if (params.data._isNew && (!params.value || params.value === "")) {
							style.border = "1px solid red";
						}

						return style;
					},
					valueSetter: (params) => {
						if (params.newValue !== undefined) {
							params.data.contract_id = params.newValue;

							// Auto-populate consultant based on contract
							const consultantId = this.onContractChangeconsultant(
								params.newValue
							);
							if (consultantId) {
								params.data.manager_id = consultantId;
							}

							// Clear mission when contract changes
							params.data.mission_id = null;

							// Refresh dependent columns
							if (this.gridApi) {
								setTimeout(() => {
									this.gridApi.refreshCells({
										rowNodes: [params.node],
										columns: ["manager_id", "mission_id"],
										force: true,
									});
								}, 0);
							}
							return true;
						}
						return false;
					},
					tooltip: (params) => {
						if (!params.data.society_id) {
							return "Veuillez d'abord sélectionner un client";
						}
						return null;
					},
				},

				// ✅ UPDATED: Filter mission_id based on contract_id AND status (1 or 3)
				{
					field: "mission_id",
					headerName: "Prestation",
					editable: (params) => this.isRowEditable(params),
					width: 200,
					cellEditor: "agSelectCellEditor",
					cellEditorParams: (params) => {
						const contractId = params.data.contract_id;
						if (!contractId) {
							return { values: [] };
						}
						let missions = [];
						// Filter missions by contract_id AND status (1 or 3)
						if (params.data._isNew) {
							// For new rows, show all missions
							missions = this.missions.filter(
								(m) => m.contract_id === parseInt(contractId)
							);
							missions = missions.sort((a, b) =>
								a.status === 1 && b.status !== 1
									? -1
									: a.status !== 1 && b.status === 1
									? 1
									: a.id - b.id
							);
						} else {
							// For existing rows, show missions based on contract_id and status
							missions = this.missions.filter(
								(m) => m.contract_id === parseInt(contractId)
							);
						}

						return {
							values: missions.map((m) => Number(m.id)),
						};
					},
					valueFormatter: (params) => {
						if (!params.value) return "";
						const missionObj = this.missions.find(
							(m) => m.id === Number(params.value)
						);
						return missionObj && missionObj.perform
							? `${params.value} - ${missionObj.perform} - ` +
									this.getContractStatus(missionObj.status)
							: params.value;
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);

						if (params.data._isNew && (!params.value || params.value === "")) {
							style.border = "1px solid red";
						}

						return style;
					},
				},

				// ✅ UPDATED: Manager (Consultant) - auto-populated but shows better info
				{
					field: "manager_id",
					headerName: "Consultant",
					headerTooltip: "Consultant ou manager responsable du backlink",
					editable: false, // Keep non-editable as it's auto-populated
					width: 150,
					valueGetter: (params) => {
						if (!params.data.manager_id && params.data.contract_id) {
							return this.onContractChangeconsultant(params.data.contract_id);
						}
						return params.data.manager_id;
					},
					valueFormatter: (params) => {
						if (!params.value) return "";
						const contract = this.contracts.find(
							(c) => c.manager_id === parseInt(params.value)
						);
						return contract && contract.manager_name
							? contract.manager_name
							: params.value;
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);

						// Gray background if no contract is selected
						if (!params.data.contract_id) {
							style.backgroundColor = "#f5f5f5";
							style.color = "#999";
						}

						return style;
					},
				},
				{
					field: "period_date",
					headerName: "Période",
					headerTooltip: "Période de création du backlink (mois/année)",
					editable: (params) => this.isRowEditable(params),
					width: 100,
					cellEditor: "agSelectCellEditor",
					comparator: (valueA, valueB) => {
						// Custom comparator for MM/YYYY date format
						if (!valueA && !valueB) return 0;
						if (!valueA) return -1;
						if (!valueB) return 1;

						// Find the corresponding date names from periodList
						const optionA = this.periodList.find((o) => o.date_value == valueA);
						const optionB = this.periodList.find((o) => o.date_value == valueB);

						// Get the date strings (MM/YYYY format)
						const dateStrA = optionA && optionA.name ? optionA.name : valueA;
						const dateStrB = optionB && optionB.name ? optionB.name : valueB;

						// Parse MM/YYYY format
						const parseDate = (dateStr) => {
							const parts = dateStr.split("/");
							if (parts.length === 2) {
								const month = parseInt(parts[0], 10);
								const year = parseInt(parts[1], 10);
								// Create comparable number: YYYYMM
								return year * 100 + month;
							}
							return 0;
						};

						const dateA = parseDate(dateStrA);
						const dateB = parseDate(dateStrB);

						return dateA - dateB;
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);

						if (params.data._isNew && (!params.value || params.value === "")) {
							style.border = "1px solid red";
						}
						return style;
					},
					cellEditorParams: (params) => {
						const value =
							params.value !== undefined ? params.value.toString() : "1";
						return {
							values: this.periodList.map((o) => o.date_value.toString()),
							defaultOption: value,
						};
					},
					valueFormatter: (params) => {
						if (params.value === undefined || params.value === null) return "";
						const option = this.periodList.find(
							(o) => o.date_value == params.value
						);
						return option && option.name ? option.name : params.value;
					},
				},
				{
					field: "url_bought",
					headerName: "Url backlinks",
					headerTooltip: "URL du site où le backlink a été acheté",
					editable: (params) => this.isRowEditable(params),
					width: 250,
					cellEditor: "agTextCellEditor",
					cellEditorParams: {
						maxLength: 200,
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);

						if (params.data._isNew && (!params.value || params.value === "")) {
							style.border = "1px solid red";
						}
						return style;
					},
					cellRenderer: (params) => {
						if (!params.value) return "";
						let url = params.value;
						if (url && !url.match(/^https?:\/\//)) {
							url = "https://" + url;
						}
						return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color: #1976d2; text-decoration: underline;">${params.value}</a>`;
					},
					valueFormatter: (params) => params.value || "",
					tooltip: (params) => {
						if (!params.value) return null;
						return `${params.value}`;
					},
				},
				{
					field: "landing_page",
					headerName: "Url landing",
					headerTooltip: "URL de la page de destination du backlink",
					editable: (params) => this.isRowEditable(params),
					width: 250,
					cellEditor: "agTextCellEditor",
					cellEditorParams: {
						maxLength: 200,
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);

						if (params.data._isNew && (!params.value || params.value === "")) {
							style.border = "1px solid red";
						}
						return style;
					},
					cellRenderer: (params) => {
						if (!params.value) return "";
						let url = params.value;
						if (url && !url.match(/^https?:\/\//)) {
							url = "https://" + url;
						}
						return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color: #1976d2; text-decoration: underline;">${params.value}</a>`;
					},
					valueFormatter: (params) => params.value || "",
					tooltip: (params) => {
						if (!params.value) return null;
						return `${params.value}`;
					},
				},
				{
					field: "provider_id",
					headerName: "Prestataire",
					headerTooltip: "Prestataire ou fournisseur du backlink",
					editable: (params) => {
						// First check if row is editable based on status
						if (!this.isRowEditable(params)) {
							return false;
						}
						// Then check if provider is editable based on period
						return this.isProviderEditable(params.data);
					},
					width: 120,
					cellEditor: "agSelectCellEditor",
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);

						// Red background for empty required fields in new rows
						if (params.data._isNew && (!params.value || params.value === "")) {
							style.border = "1px solid red";
						}

						// Gray background for non-editable cells (period > 3 months)
						if (!this.isProviderEditable(params.data)) {
							style.backgroundColor = "#f5f5f5";
							style.color = "#999";
							style.cursor = "not-allowed";
						}

						return style;
					},
					cellEditorParams: (params) => {
						const value = params.value != null ? Number(params.value) : null;
						return {
							values: this.providers.map((p) => p.id),
							defaultOption: value,
						};
					},
					valueFormatter: (params) => {
						if (
							params.value === null ||
							params.value === undefined ||
							params.value === ""
						) {
							return "";
						}
						const provider = this.providers.find(
							(p) => p.id === Number(params.value)
						);
						return provider && provider.society ? provider.society : "";
					},
					tooltip: (params) => {
						if (!this.isRowEditable(params)) {
							return "Édition bloquée : statut actif";
						}
						if (!this.isProviderEditable(params.data)) {
							return "Édition bloquée : période supérieure à 3 mois";
						}
						return null;
					},
				},
				// Commented out is_billable column for now
				// {
				// 	field: "is_billable",
				// 	headerName: "Facturable",
				// 	headerTooltip: "Indique si le backlink est facturable au client",
				// 	editable: (params) => this.isRowEditable(params),
				// 	width: 120,
				// 	cellEditor: "agSelectCellEditor",
				// 	cellEditorParams: (params) => {
				// 		const value = params.value !== undefined ? params.value : 1;
				// 		return {
				// 			values: this.facturableOptions.map((o) => Number(o.id)),
				// 			defaultOption: value,
				// 		};
				// 	},
				// 	valueFormatter: (params) => {
				// 		if (params.value === undefined || params.value === null)
				// 			return "Non renseigné";
				// 		const option = this.facturableOptions.find(
				// 			(o) => o.id === Number(params.value)
				// 		);
				// 		return option && option.label ? option.label : params.value;
				// 	},
				// 	cellStyle: (params) => this.getNonEditableCellStyle(params),
				// },
				{
					field: "price",
					headerName: "Prix d'achat HT",
					headerTooltip: "Prix d'achat du backlink hors taxes",
					editable: (params) => this.isRowEditable(params),
					width: 150,
					cellEditor: "agTextCellEditor",
					valueFormatter: (params) => {
						if (params.value !== null && params.value !== undefined) {
							return params.value + " €";
						}
						return "";
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						style.textAlign = "right";
						style.verticalAlign = "middle";

						if (params.data._isNew && (!params.value || params.value === "")) {
							style.border = "1px solid red";
						}
						return style;
					},
				},
				{
					field: "calculated_price",
					width: 150,
					headerName: "Prix de vente HT",
					headerTooltip: "Prix de vente calculé du backlink hors taxes",
					editable: (params) => this.isRowEditable(params),
					cellEditor: "agTextCellEditor",
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						style.textAlign = "right";
						style.verticalAlign = "middle";
						return style;
					},
					valueGetter: (params) => {
						if (!params.data) return null;

						// ✅ NEW: If this is from database and has calculated_price, use it
						if (
							params.data.calculated_price !== undefined &&
							params.data.calculated_price !== null
						) {
							return params.data.calculated_price;
						}

						// ✅ NEW: For new rows or when price changes, calculate it
						if (!params.data.price) return null;
						return this.calculateSalePrice(
							params.data.price,
							params.data.mission_id
						);
					},
					valueSetter: (params) => {
						if (params.newValue !== undefined && params.newValue !== null) {
							params.data.calculated_price = params.newValue;
							// ✅ NEW: Mark as manually edited (not from database)
							params.data.isCalculatedPriceFromDB = false;
							params.data.isCalculatedPriceManual = true;
							return true;
						}
						return false;
					},
					valueFormatter: (params) => {
						if (params.value !== null && params.value !== undefined) {
							return params.value + " €";
						}
						return "";
					},
				},
				{
					field: "margin",
					width: 100,
					headerName: "Tx Marge",
					headerTooltip:
						"Taux de marge calculé entre le prix d'achat et de vente",
					editable: false, // This is calculated, so keep it non-editable
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						style.textAlign = "right";
						style.verticalAlign = "middle";
						return style;
					},
					valueGetter: (params) => {
						if (!params.data || !params.data.price) return "";

						// If calculated_price is explicitly 0 or null, margin should be 0%
						if (
							params.data.calculated_price === 0 ||
							params.data.calculated_price === null ||
							params.data.calculated_price === ""
						) {
							return "0%";
						}

						const salePrice =
							params.data.calculated_price ||
							this.calculateSalePrice(
								params.data.price,
								params.data.mission_id
							);
						return this.calculateMarginPercentage(params.data.price, salePrice);
					},
					// Custom comparator for sorting by numeric margin value
					comparator: (valueA, valueB, nodeA, nodeB, isDescending) => {
						// Extract numeric values from margin strings
						const getNumericMargin = (value) => {
							if (!value || value === "N/A") return -999999; // Put N/A at the bottom
							// Remove % sign and parse as float
							return parseFloat(value.replace("%", ""));
						};

						const numA = getNumericMargin(valueA);
						const numB = getNumericMargin(valueB);

						if (numA === numB) return 0;
						return numA > numB ? 1 : -1;
					},
				},
				// Continue with all other fields following the same pattern...
				{
					field: "link_type",
					headerName: "Type de lien",
					headerTooltip:
						"Type ou catégorie du backlink (follow, nofollow, etc.)",
					editable: (params) => this.isRowEditable(params),
					width: 150,
					cellEditor: "agSelectCellEditor",
					cellEditorParams: (params) => {
						const value = params.value ? Number(params.value) : null;
						return {
							values: this.linkTypes.map((t) => t.id),
							defaultOption: value,
						};
					},
					valueFormatter: (params) => {
						if (
							params.value === null ||
							params.value === undefined ||
							params.value === ""
						) {
							return "";
						}
						const type = this.linkTypes.find(
							(t) => t.id === Number(params.value)
						);
						return type && type.name ? type.name : "";
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);

						if (params.data._isNew && (!params.value || params.value === "")) {
							style.border = "1px solid red";
						}
						return style;
					},
				},

				{
					field: "thema_id",
					headerName: "Thematique",
					headerTooltip: "Thématique ou secteur d'activité du backlink",
					editable: (params) => this.isRowEditable(params),
					cellEditor: "agSelectCellEditor",
					width: 120,
					cellEditorParams: (params) => {
						const value = params.value != null ? Number(params.value) : 1;
						return {
							values: this.themas.map((t) => t.id),
							defaultOption: value,
						};
					},
					valueFormatter: (params) => {
						if (
							params.value === null ||
							params.value === undefined ||
							params.value === ""
						) {
							return "";
						}
						const type = this.themas.find((t) => t.id == params.value);
						return type && type.name ? type.name : "";
					},
					cellStyle: (params) => this.getNonEditableCellStyle(params),
				},
				{
					field: "anchor_type",
					headerName: "Type d'ancre",
					headerTooltip:
						"Type d'ancre utilisée pour le backlink (exact match, brandé, etc.)",
					editable: (params) => this.isRowEditable(params),
					cellEditor: "agSelectCellEditor",
					width: 150,
					cellEditorParams: (params) => {
						const value = params.value != null ? Number(params.value) : 1;
						return {
							values: this.anchorTypes.map((t) => t.id),
							defaultOption: value,
						};
					},
					valueFormatter: (params) => {
						const type = this.anchorTypes.find(
							(t) => t.type_value == params.value
						);
						return type && type.type_text ? type.type_text : params.value;
					},
					cellStyle: (params) => this.getNonEditableCellStyle(params),
				},
				{
					field: "anchor",
					headerName: "Ancre",
					headerTooltip: "Texte d'ancrage du backlink",
					editable: (params) => this.isRowEditable(params),
					width: 120,
					cellEditor: "agTextCellEditor",
					cellStyle: (params) => this.getNonEditableCellStyle(params),
				},
				{
					field: "is_international",
					headerName: "International",
					headerTooltip:
						"Indique si le backlink provient d'un site international",
					editable: (params) => this.isRowEditable(params),
					width: 120,
					cellEditor: "agSelectCellEditor",
					cellEditorParams: (params) => {
						const value =
							params.value !== undefined ? params.value.toString() : "0";
						return {
							values: this.internationalOptions.map((o) => o.id.toString()),
							defaultOption: value,
						};
					},
					valueFormatter: (params) => {
						if (params.value === undefined || params.value === null)
							return "Non renseigné";
						const option = this.internationalOptions.find(
							(o) => o.id === parseInt(params.value)
						);
						return option && option.label ? option.label : params.value;
					},
					cellStyle: (params) => this.getNonEditableCellStyle(params),
				},
				{
					field: "renew_duration",
					headerName: "Renew",
					headerTooltip: "Durée de renouvellement du backlink en mois",
					editable: (params) => this.isRowEditable(params),
					cellEditor: "agSelectCellEditor",
					width: 100,
					cellEditorParams: (params) => {
						const value = params.value ? params.value : 0;
						return {
							values: this.renewDurations.map((d) => Number(d.id)),
							defaultOption: value,
						};
					},
					valueFormatter: (params) => {
						if (!params.value && params.value !== 0) return "Non renseigné";
						const duration = this.renewDurations.find(
							(d) => d.id === Number(params.value)
						);
						return duration && duration.label ? duration.label : params.value;
					},
					cellStyle: (params) => this.getNonEditableCellStyle(params),
				},
				{
					field: "renew_date",
					headerName: "Date de renew",
					headerTooltip: "Date prévue de renouvellement du backlink",
					editable: false, // This is calculated, so keep it non-editable
					width: 130,
					valueFormatter: (params) => {
						return this.formatTimeStamp(params.value);
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						style.textAlign = "right";
						style.verticalAlign = "middle";
						return style;
					},
				},

				{
					field: "creation_date",
					headerName: "Création",
					headerTooltip: "Date de création du backlink dans le système",
					editable: false, // This field should generally not be editable
					cellEditor: "agDateCellEditor",
					cellEditorParams: {
						min: "2000-01-01",
						max: "2030-12-31",
					},
					width: 100,
					valueFormatter: (params) => {
						return this.formatTimeStamp(params.value);
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						style.textAlign = "right";
						style.verticalAlign = "middle";
						return style;
					},
				},
				{
					field: "additional_domdetailers.data",
					headerName: "DA",
					headerTooltip: "Domain Authority (Moz)",
					editable: false,
					width: 70,
					valueGetter: (params) => {
						var data = params.data;
						try {
							var parsed =
								data &&
								data.additional_domdetailers &&
								JSON.parse(data.additional_domdetailers);
							var value = parsed && parsed.data && parsed.data.mozDA;
							return value
								? this.convertInternationalNumberToFrench(value)
								: "";
						} catch (e) {
							return "";
						}
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						style.textAlign = "center";
						style.verticalAlign = "middle";
						return style;
					},
				},
				{
					field: "additional_domdetailers.data",
					headerName: "CF",
					headerTooltip: "Citation Flow (Majestic)",
					editable: false,
					width: 70,
					valueGetter: (params) => {
						var data = params.data;
						try {
							var parsed =
								data &&
								data.additional_domdetailers &&
								JSON.parse(data.additional_domdetailers);
							var value = parsed && parsed.data && parsed.data.majesticCF;
							return value
								? this.convertInternationalNumberToFrench(value)
								: "";
						} catch (e) {
							return "";
						}
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						style.textAlign = "center";
						style.verticalAlign = "middle";
						return style;
					},
				},
				{
					field: "additional_domdetailers.data",
					headerName: "TF",
					headerTooltip: "Trust Flow (Majestic)",
					editable: false,
					width: 70,
					valueGetter: (params) => {
						var data = params.data;
						try {
							var parsed =
								data &&
								data.additional_domdetailers &&
								JSON.parse(data.additional_domdetailers);
							var value = parsed && parsed.data && parsed.data.majesticTF;
							return value
								? this.convertInternationalNumberToFrench(value)
								: "";
						} catch (e) {
							return "";
						}
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						style.textAlign = "center";
						style.verticalAlign = "middle";
						return style;
					},
				},
				{
					field: "additional_domdetailers.data",
					headerName: "RD",
					headerTooltip: "Referring Domains (Majestic)",
					editable: false,
					width: 120,
					valueGetter: (params) => {
						var data = params.data;
						try {
							var parsed =
								data &&
								data.additional_domdetailers &&
								JSON.parse(data.additional_domdetailers);
							var value =
								parsed && parsed.data && parsed.data.majesticRefDomains;
							return value
								? this.convertInternationalNumberToFrench(value)
								: "";
						} catch (e) {
							return "";
						}
					},
					cellStyle: (params) => {
						let style = this.getNonEditableCellStyle(params);
						style.textAlign = "center";
						style.verticalAlign = "middle";
						return style;
					},
				},
				{
					headerName: "Actions",
					headerTooltip:
						"Actions disponibles pour ce backlink (supprimer, modifier, etc.)",
					field: "actions",
					editable: false,
					sortable: false,
					width: 150,
					cellRenderer: (params) => {
						const eDiv = document.createElement("div");
						eDiv.classList.add("action-buttons");

						if (params.data._isNew) {
							const clearButton = document.createElement("button");
							clearButton.className = "";
							clearButton.innerHTML = "Annuler";
							clearButton.style.backgroundColor = "#f44336";
							clearButton.style.color = "#ffffff";
							clearButton.style.border = "none";
							clearButton.style.padding = "5px 10px";
							clearButton.style.marginLeft = "5px";
							clearButton.style.borderRadius = "4px";
							clearButton.style.cursor = "pointer";
							clearButton.style.fontSize = "12px";
							clearButton.addEventListener("click", () =>
								this.clearNewRow(params.data, params.rowIndex)
							);
							eDiv.appendChild(clearButton);
						} else {
							const deleteButton = document.createElement("button");
							deleteButton.className = "pd-5";
							deleteButton.style.backgroundColor = "#f44336";
							deleteButton.style.color = "#ffffff";
							deleteButton.style.border = "none";
							deleteButton.style.padding = "5px 10px";
							deleteButton.style.marginLeft = "5px";
							deleteButton.style.borderRadius = "4px";
							deleteButton.style.cursor = "pointer";
							deleteButton.style.fontSize = "12px";
							deleteButton.innerHTML = "Supprimer";

							// Disable delete button if status is Actif (0) - except for Super Administrateur
							if (
								params.data.status === 0 &&
								(!this.activeUser || this.activeUser.type != 9)
							) {
								deleteButton.disabled = true;
								deleteButton.style.backgroundColor = "#cccccc";
								deleteButton.style.cursor = "not-allowed";
								deleteButton.title = "Suppression bloquée : statut actif";
							} else {
								deleteButton.onmouseover = function () {
									this.style.backgroundColor = "#d32f2f";
								};
								deleteButton.onmouseout = function () {
									this.style.backgroundColor = "#f44336";
								};
								deleteButton.addEventListener("click", () =>
									this.deleteNetlink(params.data)
								);
							}

							eDiv.appendChild(deleteButton);
						}

						return eDiv;
					},
				},
			];
		},
		// ✅ NEW: Updated createNewRow method
		createNewRow() {
			const newRow = {
				society_id: null, // ✅ Start with null, user must select
				contract_id: null, // ✅ Will be populated based on society
				manager_id: null, // ✅ Will be populated based on contract
				mission_id: null, // ✅ Will be populated based on contract
				url_bought: "",
				landing_page: "",
				provider_id: null,
				thema_id: null,
				anchor_type: null,
				anchor: "",
				link_type: null,
				renew_duration: 0,
				renew_date: null, // Null when renew_duration is 0 (A vie)
				status: 1,
				period_date: moment().format("MM/YYYY"),
				is_international: 0,
				is_billable: 0,
				price: null,
				calculated_price: null,
				isCalculatedPriceFromDB: false,
				creation_date: new Date().toISOString().split("T")[0],
				_isNew: true,
				_isDuplicate: false,
			};

			return newRow;
		},

		// ✅ NEW: Add method to get available contracts for a society
		getContractsForSociety(societyId) {
			if (!societyId) return [];
			return this.contracts.filter((c) => c.society_id === parseInt(societyId));
		},

		// ✅ NEW: Add method to get available missions for a contract with status filter
		getMissionsForContract(contractId) {
			if (!contractId) return [];
			return this.missions.filter(
				(m) =>
					m.contract_id === parseInt(contractId) &&
					(m.status === 1 || m.status === 3)
			);
		},
		/**
		 * Check if provider field can be edited based on period date
		 * @param {Object} rowData - The row data
		 * @returns {boolean} - True if editable, false otherwise
		 */
		isProviderEditable(rowData) {
			// Always allow editing for new rows
			if (rowData._isNew) {
				return true;
			}

			// Super Administrateur can edit provider_id regardless of period
			if (this.activeUser && this.activeUser.type == 9) {
				return true;
			}

			// If no period_date, allow editing
			if (!rowData.period_date) {
				return true;
			}

			try {
				// Parse the period date (format: MM/YYYY)
				const periodParts = rowData.period_date.split("/");
				if (periodParts.length !== 2) {
					return true; // If format is invalid, allow editing
				}

				const month = parseInt(periodParts[0], 10) - 1; // Month is 0-indexed in Date
				const year = parseInt(periodParts[1], 10);

				// Create date object for the period (first day of the month)
				const periodDate = new Date(year, month, 1);
				const currentDate = new Date();

				// Calculate the difference in months
				const monthsDifference = this.getMonthsDifference(
					periodDate,
					currentDate
				);

				// Return false if period is more than 3 months old
				return monthsDifference <= 3;
			} catch (error) {
				console.error("Error parsing period date:", error);
				return true; // If error, allow editing as fallback
			}
		},

		/**
		 * Calculate the difference in months between two dates
		 * @param {Date} startDate - The start date
		 * @param {Date} endDate - The end date
		 * @returns {number} - Number of months difference
		 */
		getMonthsDifference(startDate, endDate) {
			const yearsDifference = endDate.getFullYear() - startDate.getFullYear();
			const monthsDifference = endDate.getMonth() - startDate.getMonth();
			return yearsDifference * 12 + monthsDifference;
		},
		onContractChange(contractId) {
			if (!contractId) {
				// If no contract is selected, clear the society
				this.netlinks.society_id = null;
				return;
			}

			// Find the selected contract in the contracts list
			const selectedContract = this.contracts.find(
				(c) => c.id === parseInt(contractId)
			);

			if (selectedContract && selectedContract.society_id) {
				// If we found the contract and it has a society_id, update the society
				return selectedContract.society_id;
			}

			return null;
		},
		onContractChangeMission(contractId) {
			if (!contractId) {
				// If no contract is selected, clear the society
				this.netlinks.society_id = null;
				return;
			}

			// Find the selected contract in the contracts list
			const missionsList = this.missions.find(
				(c) => c.contract_id === parseInt(contractId)
			);

			if (missionsList.length > 0) {
				// If we found the contract and it has a society_id, update the society
				return selectedContract.missionsList;
			}

			return null;
		},
		onContractChangeconsultant(contractId) {
			if (!contractId) {
				// If no contract is selected, clear the society
				// this.netlinks.society_id = null;
				return;
			}
			// Find the selected contract in the contracts list
			const selectedContract = this.contracts.find(
				(c) => c.id === parseInt(contractId)
			);

			if (selectedContract && selectedContract.manager_id) {
				// If we found the contract and it has a society_id, update the society
				return selectedContract.manager_id;
			}

			return null;
		},
		getStatusColor(statusValue) {
			if (statusValue === undefined || statusValue === null) return null;

			const status = parseInt(statusValue);
			// Option 1: Map by status value
			const colorMap = {
				0: "#ffebee", // Inactive - Light red
				1: "#e8f5e9", // Active - Light green
				2: "#fff3e0", // Pending - Light orange
				3: "#e3f2fd", // In Review - Light blue
				4: "#fce4ec", // Expired - Light pink
				5: "#f3e5f5", // Other - Light purple
				6: "#ff702e", // Litige - Orange warning
			};
			return colorMap[status] || null;
		},
		formatPeriod(periodString) {
			if (!periodString) return "";

			try {
				const [month, year] = periodString.split("/");
				const monthNames = [
					"Janvier",
					"Février",
					"Mars",
					"Avril",
					"Mai",
					"Juin",
					"Juillet",
					"Août",
					"Septembre",
					"Octobre",
					"Novembre",
					"Décembre",
				];

				const monthIndex = parseInt(month, 10) - 1;
				if (isNaN(monthIndex) || monthIndex < 0 || monthIndex > 11) {
					return periodString;
				}
				return `${monthNames[monthIndex]} ${year}`;
			} catch (e) {
				console.error("Erreur de formatage de période:", e);
				return periodString;
			}
		},
		formatTimeStamp(dateString) {
			if (!dateString) return "";

			try {
				const date = new Date(dateString);

				// Vérifier si la date est valide
				if (isNaN(date.getTime())) return "";

				// Format: DD/MM/YYYY
				return date.toLocaleDateString("fr-FR", {
					day: "2-digit",
					month: "2-digit",
					year: "2-digit",
				});
			} catch (e) {
				console.error("Erreur de formatage de date:", e);
				return "";
			}
		},
		getFilteredNetlinks() {
			return Netlink.getFilteredNetlinks(this.queries, this.currentx)
				.then((res) => {
					this.netlinks = res.data;
					return res;
				})
				.catch((err) => {
					console.error(err);
					this.$vs.notify({
						title: "Erreur",
						text: "Une erreur est survenue lors de la récupération des netlinks",
						iconPack: "feather",
						icon: "alert-circle",
						color: "danger",
					});
					return [];
				});
		},
		getNetlinkStatus() {
			return Netlink.getNetlinkStatus()
				.then((res) => {
					this.netlinkStatus = res;
					return res;
				})
				.catch((err) => {
					console.error(err);
					return [];
				});
		},
		getNetlinkAnchorTypes() {
			return Netlink.getNetlinkAnchorTypes()
				.then((res) => {
					this.anchorTypes = res;
					return res;
				})
				.catch((err) => {
					console.error(err);
					return [];
				});
		},
		getProviders() {
			return Provider.getAll()
				.then((res) => {
					this.providers = res;
					return res;
				})
				.catch((err) => {
					console.error(err);
					return [];
				});
		},
		getNetlinkThemas() {
			return Netlink.getThemas()
				.then((res) => {
					return res;
				})
				.catch((err) => {
					console.error(err);
					return [];
				});
		},
		getNetlinkTypes() {
			return Netlink.getTypes()
				.then((res) => {
					this.linkTypes = res;
					return res;
				})
				.catch((err) => {
					console.error(err);
					return [];
				});
		},
		async onBtAddRow() {
			// Check if there are existing unsaved new rows that need to be saved first
			if (this.newRows.size > 0) {
				// Get all new rows that need to be saved
				const unsavedNewRows = Array.from(this.newRows)
					.map((index) => ({
						index,
						netlink: this.netlinks[index],
					}))
					.filter((item) => item.netlink && item.netlink._isNew);

				// Process each unsaved row
				for (const { netlink, index } of unsavedNewRows) {
					// Check if the row has minimum required fields
					if (this.isValidNetlink(netlink)) {
						// Check for duplicates with existing netlinks
						const isDuplicate = this.checkNetlinkDuplicate(netlink);

						if (isDuplicate) {
							// Mark as duplicate and show error
							this.$set(this.netlinks[index], "_isDuplicate", true);

							// Force grid refresh to show yellow styling
							if (this.gridApi) {
								this.gridApi.refreshCells({ force: true });
							}

							this.$vs.notify({
								title: "Erreur: Doublon détecté",
								text: `Un netlink actif existe déjà: ${netlink.url_bought} -> ${netlink.landing_page}`,
								iconPack: "feather",
								icon: "x-circle",
								color: "danger",
								time: 5000,
							});
							return; // Don't add new row if duplicate exists
						}

						// Try to save the netlink
						try {
							const netlinkToSave = this.prepareNetlinkForSave({ ...netlink });
							delete netlinkToSave._isNew;
							delete netlinkToSave._isDuplicate;

							const res = await Netlink.createNetlink(netlinkToSave);

							// Update the netlink with the saved ID
							this.$set(this.netlinks[index], "id", res.id);
							this.$set(this.netlinks[index], "_isNew", false);
							this.$set(this.netlinks[index], "_isDuplicate", false);

							// Remove from newRows tracking
							this.newRows.delete(index);

							// Update original data tracking
							if (res.id) {
								this.originalNetlinks[res.id] = JSON.parse(
									JSON.stringify(this.netlinks[index])
								);
							}

							this.$vs.notify({
								title: "Succès",
								text: "Netlink enregistré avec succès",
								iconPack: "feather",
								icon: "check-circle",
								color: "success",
								time: 2000,
							});
						} catch (err) {
							console.error("Save error:", err);

							// Check if it's a duplicate error from backend
							if (err.response && err.response.status === 409) {
								this.$set(this.netlinks[index], "_isDuplicate", true);
								this.$vs.notify({
									title: "Erreur: Doublon",
									text: "Ce netlink existe déjà dans la base de données",
									iconPack: "feather",
									icon: "alert-triangle",
									color: "danger",
									time: 5000,
								});
							} else {
								this.$vs.notify({
									title: "Erreur",
									text: `Impossible d'enregistrer le netlink: ${
										err.message || "Erreur inconnue"
									}`,
									iconPack: "feather",
									icon: "x-circle",
									color: "danger",
									time: 5000,
								});
							}
							return; // Don't add new row if save failed
						}
					} else {
						// Show what fields are missing
						const missingFields = [];
						if (!netlink.url_bought) missingFields.push("URL backlinks");
						if (!netlink.landing_page) missingFields.push("URL landing");
						if (!netlink.provider_id) missingFields.push("Prestataire");
						if (!netlink.mission_id) missingFields.push("Prestation");
						if (!netlink.contract_id) missingFields.push("Contrat");

						this.$vs.notify({
							title: "Erreur: Champs requis manquants",
							text: `Complétez les champs suivants: ${missingFields.join(
								", "
							)}`,
							iconPack: "feather",
							icon: "alert-circle",
							color: "danger",
							time: 4000,
						});
						return; // Don't add new row if current row is incomplete
					}
				}
			}

			// If we get here, either there were no unsaved rows or they were all saved successfully
			// Now add the new row
			const newRow = this.createNewRow();

			// Ajout des propriétés spécifiques au contrat
			newRow.contract_id = this.contractId;

			// Get current row data
			const currentRowData = [...this.netlinks];

			// Add the new row at the beginning
			currentRowData.unshift(newRow);

			// Mark as new row
			this.newRows.add(0); // Track by row index

			// Update the row data
			this.netlinks = currentRowData;

			// After row is added, start editing it
			// this.$nextTick(() => {
			// 	if (this.gridApi) {
			// 		this.gridApi.setFocusedCell(0, "provider_id");
			// 		this.gridApi.startEditingCell({
			// 			rowIndex: 0,
			// 			colKey: "provider_id",
			// 		});
			// 	}
			// });
		},
		clearNewRow(netlink, rowIndex) {
			// Remove the new row from the grid
			if (rowIndex !== undefined) {
				this.netlinks.splice(rowIndex, 1);
				this.newRows.delete(rowIndex);
				this.tableKey++; // Force refresh

				this.$vs.notify({
					title: "Information",
					text: "Nouvelle ligne annulée",
					iconPack: "feather",
					icon: "info",
					color: "primary",
				});
			}
		},
		// ✅ UPDATED: calculateSalePrice now accepts missionId parameter
		calculateSalePrice(purchasePrice, missionId = null) {
			if (!purchasePrice) return null;

			const pa =
				typeof purchasePrice === "string"
					? Number(purchasePrice)
					: purchasePrice;

			console.log(
				"Calculating sale price for PA:",
				pa,
				"Mission ID:",
				missionId
			);
			if (isNaN(pa)) return null;

			// Check if mission has is_no_marge flag set (handles 1, "1", true, "true")
			if (missionId) {
				const mission = this.missions.find((m) => m.id === Number(missionId));
				if (
					mission &&
					(mission.is_no_marge === true ||
						mission.is_no_marge === 1 ||
						mission.is_no_marge === "1" ||
						mission.is_no_marge === "true")
				) {
					console.log(
						"Mission with is_no_marge detected - keeping sell price same as purchase price",
						"Mission ID:",
						missionId,
						"is_no_marge value:",
						mission.is_no_marge
					);
					return pa; // Return the same price without any markup
				}
			}

			// Original logic for other missions
			let multiplier;

			if (pa < 250) {
				multiplier = 2; // 100% margin => gain = 1 × PA => PA + PA = 2PA
			} else if (pa >= 2000) {
				multiplier = 1.5; // 50% margin => gain = 0.5 × PA => 1.5PA
			} else {
				// Linear degressive margin from 2 (at 250€) to 1.5 (at 2000€)
				const slope = (2 - 1.5) / (250 - 2000); // negative slope
				multiplier = 2 + slope * (pa - 250);
			}

			return Math.round(pa * multiplier);
		},

		// ✅ UPDATED: calculateMarginPercentage handles 0% margin cases
		calculateMarginPercentage(pa, pv) {
			// If no purchase price, return N/A
			if (!pa || pa === 0) return "N/A";

			// If no sell price, margin is 0%
			if (!pv || pv === 0) return "0%";

			// If purchase price equals sale price (like for mission_id 105), margin is 0%
			if (pa === pv) return "0%";

			return Math.round(((pv - pa) / pa) * 100) + "%";
		},
		// ✅ FIXED: Enhanced onCellValueChanged method using INDEX-BASED tracking
		onCellValueChanged(event) {
			console.log(
				"onCellValueChanged: " + event.colDef.field + " = " + event.newValue
			);

			// ✅ CRITICAL FIX: Track the changed row BY ROW INDEX instead of ID
			if (event.data._isNew) {
				if (this.gridApi) {
					this.gridApi.refreshCells({
						rowNodes: [event.node],
						columns: [event.colDef.field],
						force: true,
					});
				}
			} else {
				// Track as modified row by netlink ID (not rowIndex, which changes with filters)
				if (event.data.id) {
					this.modifiedRows.add(event.data.id);
				}
			}

			// Check for duplicates when key fields change
			if (
				["url_bought", "landing_page", "contract_id", "period_date"].includes(
					event.colDef.field
				)
			) {
				// Check and mark duplicate immediately
				this.checkAndMarkDuplicate(event.data, event.rowIndex);
			}

			// Check domain existence via API when url_bought changes
			if (event.colDef.field === "url_bought" && event.newValue) {
				this.checkDomainExists(event.newValue, event.data.society_id);
			}

			// Handle status changes
			if (event.colDef.field === "status") {
				this.handleStatusChange(event);
				return;
			}

			// ✅ NEW: Handle society_id changes
			if (event.colDef.field === "society_id" && event.newValue) {
				// Clear dependent fields
				event.data.contract_id = null;
				event.data.mission_id = null;
				event.data.manager_id = null;

				// Refresh dependent columns
				if (this.gridApi) {
					setTimeout(() => {
						this.gridApi.refreshCells({
							rowNodes: [event.node],
							columns: ["contract_id", "mission_id", "manager_id"],
							force: true,
						});
					}, 0);
				}
			}

			// ✅ UPDATED: Handle contract_id changes
			if (event.colDef.field === "contract_id" && event.newValue) {
				const consultantId = this.onContractChangeconsultant(event.newValue);

				// Clear mission when contract changes
				event.data.mission_id = null;

				if (consultantId && event.data.manager_id !== consultantId) {
					event.data.manager_id = consultantId;
				}

				if (this.gridApi) {
					setTimeout(() => {
						this.gridApi.refreshCells({
							rowNodes: [event.node],
							columns: ["manager_id", "mission_id"],
							force: true,
						});
					}, 0);
				}
			}

			// Handle mission_id changes
			if (event.colDef.field === "mission_id" && event.data.price) {
				if (
					!event.data.isCalculatedPriceFromDB ||
					event.data.isCalculatedPriceManual
				) {
					const newCalculated = this.calculateSalePrice(
						event.data.price,
						event.newValue
					);
					event.data.calculated_price = newCalculated;
					event.node.setDataValue("calculated_price", newCalculated);
					this.gridApi.refreshCells({
						rowNodes: [event.node],
						columns: ["calculated_price", "margin"],
						force: true,
					});
				}
			}

			// Handle manual calculated_price changes
			if (event.colDef.field === "calculated_price") {
				event.data.isCalculatedPriceManual = true;
				event.data.isCalculatedPriceFromDB = false;
				this.gridApi.refreshCells({
					rowNodes: [event.node],
					columns: ["margin"],
					force: true,
				});
			}

			// Handle price changes - always recalculate sell_price and margin
			if (event.colDef.field === "price") {
				const newCalculated = this.calculateSalePrice(
					event.newValue,
					event.data.mission_id
				);
				event.data.calculated_price = newCalculated;
				event.data.isCalculatedPriceFromDB = false;
				event.node.setDataValue("calculated_price", newCalculated);
				this.gridApi.refreshCells({
					rowNodes: [event.node],
					columns: ["calculated_price", "margin"],
					force: true,
				});
			}

			// Handle renew duration and creation date changes
			if (
				event.colDef.field === "renew_duration" ||
				event.colDef.field === "creation_date"
			) {
				if (event.data.creation_date) {
					const renewDate = this.calculateRenewDate(
						event.data.creation_date,
						event.data.renew_duration
					);
					event.data.renew_date = renewDate;
					event.node.setDataValue("renew_date", renewDate);
					this.gridApi.refreshCells({
						rowNodes: [event.node],
						columns: ["renew_date"],
						force: true,
					});
				}
			}
		},
		onRowValueChanged(event) {
			const data = event.data;
			console.log("onRowValueChanged:", data);

			// Validate required fields
			const missingRequired = [];

			if (!data.url_bought) missingRequired.push("URL backlinks");
			if (!data.landing_page) missingRequired.push("URL landing");
			if (!data.provider_id) missingRequired.push("Prestataire");
			if (!data.link_type && data.link_type !== 0)
				missingRequired.push("Type de lien");
			if (!data.price && data.price !== 0)
				missingRequired.push("Prix d'achat HT");

			if (missingRequired.length > 0) {
				this.$vs.notify({
					title: "Champs obligatoires",
					text: `Les champs suivants sont obligatoires: ${missingRequired.join(
						", "
					)}`,
					iconPack: "feather",
					icon: "alert-circle",
					color: "warning",
				});
				return;
			}
		},
		// ✅ MODIFICATION: prepareNetlinkForSave pour garder les valeurs null
		// ✅ UPDATED: prepareNetlinkForSave method
		prepareNetlinkForSave(netlink) {
			console.log("Preparing netlink for save:", netlink);

			// Your existing fields
			netlink.mission_id = netlink.mission_id || null;
			netlink.url_bought = netlink.url_bought || "";
			netlink.landing_page = netlink.landing_page || "";
			netlink.anchor_type = netlink.anchor_type || null;
			netlink.anchor = netlink.anchor || "";
			netlink.status = netlink.status !== undefined ? netlink.status : 0;

			netlink.link_type =
				netlink.link_type !== undefined ? netlink.link_type : null;
			netlink.provider_id =
				netlink.provider_id !== undefined ? netlink.provider_id : null;

			netlink.contract_id = netlink.contract_id || this.contractId;
			netlink.thema_id = netlink.thema_id || null;
			netlink.society_name = netlink.society_name || this.societyName;
			netlink.society_id =
				netlink.society_id || (this.mission ? this.mission.society_id : null);
			netlink.is_billable =
				netlink.is_billable !== undefined ? netlink.is_billable : 1;

			// API required fields
			netlink.domain_authority = netlink.domain_authority || 0;
			netlink.page_authority = netlink.page_authority || 0;
			netlink.trust_flow = netlink.trust_flow || 0;
			netlink.citation_flow = netlink.citation_flow || 0;
			netlink.external_links = netlink.external_links || 0;
			netlink.ref_domains = netlink.ref_domains || 0;
			netlink.user_id = this.activeUser.id;

			// ✅ UPDATED: sell_price handling - preserve database value or use calculated
			if (
				netlink.calculated_price !== undefined &&
				netlink.calculated_price !== null
			) {
				netlink.sell_price = netlink.calculated_price;
			} else if (netlink.price) {
				// Only calculate if we don't have a calculated_price
				netlink.sell_price = this.calculateSalePrice(
					netlink.price,
					netlink.mission_id
				);
			} else {
				netlink.sell_price = 0;
			}

			// Date handling
			if (!netlink.creation_date) {
				netlink.creation_date = new Date().toISOString().split("T")[0];
			}

			// Calculate renewal date based on creation date and renewal duration
			if (netlink.creation_date) {
				netlink.renew_date = this.calculateRenewDate(
					netlink.creation_date,
					netlink.renew_duration !== undefined ? netlink.renew_duration : 0
				);
			}

			// Other numeric fields
			netlink.is_international =
				netlink.is_international !== undefined ? netlink.is_international : 0;
			netlink.price = netlink.price || 0;
			netlink.renew_duration =
				netlink.renew_duration !== undefined ? netlink.renew_duration : 0;

			// Include the flag is_remove_purchase
			netlink.is_remove_purchase =
				netlink.is_remove_purchase !== undefined
					? netlink.is_remove_purchase
					: false;

			// ✅ NEW: Clean up temporary flags before saving
			delete netlink.isCalculatedPriceFromDB;
			delete netlink.isCalculatedPriceManual;
			delete netlink._isDuplicate;
			delete netlink._existingId;

			return netlink;
		},
		hasNetlinkChanged(netlink) {
			// If it's a new netlink, it's changed by definition
			if (netlink._isNew) return true;

			// If we don't have the original data, assume it's changed
			if (!netlink.id || !this.originalNetlinks[netlink.id]) return true;

			const original = this.originalNetlinks[netlink.id];

			// Fields to ignore in comparison
			const ignoreFields = [
				"_isNew",
				"calculated_price",
				"margin",
				"_isDuplicate",
				"_existingId",
			];

			// Check each field for differences
			for (const key in netlink) {
				if (ignoreFields.includes(key)) continue;
				if (netlink[key] !== original[key]) {
					console.log(
						`Field '${key}' changed: ${original[key]} → ${netlink[key]}`
					);
					return true;
				}
			}
			console.log("Comparing netlink:", netlink.id);
			console.log("Original:", this.originalNetlinks[netlink.id]);
			console.log("Current:", netlink);

			return false;
		},
		isValidNetlink(netlink) {
			// Check if the netlink has the minimum required fields
			return (
				netlink &&
				netlink.url_bought &&
				netlink.url_bought.trim() !== "" &&
				netlink.landing_page &&
				netlink.landing_page.trim() !== "" &&
				netlink.mission_id &&
				netlink.society_id
			);
		},

		// Extract domain from URL for duplicate detection
		extractDomain(url) {
			if (!url || typeof url !== "string") {
				return null;
			}

			try {
				let cleanUrl = url.trim();

				// Add protocol if missing
				if (
					!cleanUrl.startsWith("http://") &&
					!cleanUrl.startsWith("https://")
				) {
					cleanUrl = `http://${cleanUrl}`;
				}

				const urlObj = new URL(cleanUrl);
				let domain = urlObj.hostname;

				// Remove www prefix
				if (domain.startsWith("www.")) {
					domain = domain.substring(4);
				}

				return domain.toLowerCase();
			} catch (error) {
				// If URL parsing fails, try to extract domain manually
				let domain = url
					.trim()
					.replace(/^https?:\/\//, "")
					.replace(/^www\./, "")
					.split("/")[0]
					.split("?")[0];
				return domain.toLowerCase();
			}
		},
		checkNetlinkDuplicate(netlink) {
			// Only check for duplicates if the new netlink is actif (status = 0)
			// Status 1 (en attente) can be created without duplicate checking since URL is incomplete
			if (
				!netlink.url_bought ||
				!netlink.landing_page ||
				netlink.status !== 0
			) {
				return false;
			}

			// Extract domain from the netlink being checked
			const currentDomain = this.extractDomain(netlink.url_bought);
			if (!currentDomain) {
				return false;
			}

			return this.existingNetlinks.some((existing) => {
				if (!existing.url_bought || !existing.landing_page) {
					return false;
				}

				// IMPORTANT: Skip self when checking duplicates (if editing existing netlink)
				if (netlink.id && existing.id === netlink.id) {
					return false;
				}

				// Only check against active netlinks (status = 0)
				if (existing.status !== 0) {
					return false;
				}

				// Extract domain from existing netlink
				const existingDomain = this.extractDomain(existing.url_bought);

				// Check for domain-level duplicates (same domain + contract + period)
				return (
					existingDomain === currentDomain &&
					existing.contract_id == netlink.contract_id &&
					existing.period_date == netlink.period_date
				);
			});
		},

		checkAndMarkDuplicate(netlink, rowIndex) {
			// Check if this netlink is a duplicate and mark it accordingly
			if (this.isValidNetlink(netlink)) {
				const isDuplicate = this.checkNetlinkDuplicate(netlink);

				// Update the duplicate flag
				this.$set(this.netlinks[rowIndex], "_isDuplicate", isDuplicate);

				// Force grid refresh to show styling changes
				if (this.gridApi) {
					this.gridApi.refreshCells({ force: true });
				}
			}
		},

		// Check domain existence via API
		async checkDomainExists(url_bought, society_id = null) {
			if (!url_bought || url_bought.trim() === "") {
				return;
			}

			try {
				const response = await Netlink.checkDomain(url_bought, society_id);

				if (
					response.success &&
					response.exists &&
					response.netlinks &&
					response.netlinks.length > 0
				) {
					// Build detailed message with existing netlinks
					let message = `Le domaine "${response.domain}" a déjà été dans le période ${response.netlinks[0].period_date}\n\n`;

					// response.netlinks.forEach((nl, index) => {
					// 	message += `${index + 1}. Contrat: ${nl.contract_id}`;
					// 	if (nl.period_date) {
					// 		message += ` | Période: ${nl.period_date}`;
					// 	}
					// 	message += `\n   URL: ${nl.url_bought}\n`;
					// 	message += `   Landing: ${nl.landing_page}\n\n`;
					// });

					this.$vs.notify({
						title: "Attention: Domaine déjà acheté",
						text: message,
						iconPack: "feather",
						icon: "alert-triangle",
						color: "warning",
						time: 8000,
					});

					return true;
				}

				return false;
			} catch (error) {
				console.error("Error checking domain:", error);
				return false;
			}
		},

		saveNetlink(netlink) {
			// Prepare the netlink object for save (clean up any temporary fields)
			const netlinkToSave = { ...netlink };
			delete netlinkToSave._isNew;
			delete netlinkToSave._isDuplicate;
			// netlinkToSave.mission_id = this.$props.mission.id;

			// If the netlink has an ID, it's an update, otherwise it's a creation
			if (netlinkToSave.id) {
				Netlink.updateNetlink(netlinkToSave.id, netlinkToSave)
					.then((res) => {
						this.$vs.notify({
							title: "Succès",
							text: "Netlink mis à jour avec succès",
							iconPack: "feather",
							icon: "check-circle",
							color: "success",
						});

						// Remove from modified list if exists
						const rowIndex = this.netlinks.findIndex(
							(n) => n.id === netlinkToSave.id
						);
						if (rowIndex !== -1) {
							this.modifiedRows.delete(rowIndex);
							// Remove duplicate flag if it was set
							this.$set(this.netlinks[rowIndex], "_isDuplicate", false);
						}
					})
					.catch((err) => {
						console.error(err);

						// Check if it's a 409 conflict (duplicate)
						if (err.response && err.response.status === 409) {
							const rowIndex = this.netlinks.findIndex(
								(n) => n.id === netlinkToSave.id
							);
							if (rowIndex !== -1) {
								// Mark as duplicate
								this.$set(this.netlinks[rowIndex], "_isDuplicate", true);
							}

							this.$vs.notify({
								title: "Doublon détecté",
								text: "Ce netlink existe déjà pour cette période et ce contrat",
								iconPack: "feather",
								icon: "alert-triangle",
								color: "warning",
								time: 6000,
							});
						} else {
							this.$vs.notify({
								title: "Erreur",
								text: "Une erreur est survenue lors de la mise à jour du netlink",
								iconPack: "feather",
								icon: "alert-circle",
								color: "danger",
							});
						}
					});
			} else {
				Netlink.createNetlink(netlinkToSave)
					.then((res) => {
						// Update the row with the ID from server
						const rowIndex = this.netlinks.findIndex((n) => n === netlink);
						if (rowIndex !== -1) {
							// Update the row with the new ID and remove _isNew flag
							this.$set(this.netlinks, rowIndex, {
								...netlinkToSave,
								id: res.id,
								_isDuplicate: false,
							});

							// Remove from new rows tracking
							this.newRows.delete(rowIndex);

							// Update the grid
							if (this.gridApi) {
								this.gridApi.refreshCells({ force: true });
							}
						}

						this.$vs.notify({
							title: "Succès",
							text: "Netlink créé avec succès",
							iconPack: "feather",
							icon: "check-circle",
							color: "success",
						});
					})
					.catch((err) => {
						console.error(err);

						// Check if it's a 409 conflict (duplicate)
						if (err.response && err.response.status === 409) {
							// Only show duplicate warning if the netlink is actif (status = 0)
							// For status 1 (en attente), allow creation since URL is incomplete
							if (netlink.status === 0) {
								// Mark the row as duplicate but keep it in the table
								const rowIndex = this.netlinks.findIndex((n) => n === netlink);
								if (rowIndex !== -1) {
									// Mark as duplicate
									this.$set(this.netlinks[rowIndex], "_isDuplicate", true);
									// Keep it in newRows so it shows as unsaved
									// this.newRows.add(rowIndex); // Already in newRows
								}

								this.$vs.notify({
									title: "Doublon détecté",
									text: `Ce netlink actif existe déjà: ${netlink.url_bought} -> ${netlink.landing_page} pour la période ${netlink.period_date}. Voulez-vous modifier l'existant ?`,
									iconPack: "feather",
									icon: "alert-triangle",
									color: "warning",
									time: 8000,
								});
							} else {
								// For status 1 (en attente), treat as successful creation
								// Update the row with success since URL is incomplete anyway
								const rowIndex = this.netlinks.findIndex((n) => n === netlink);
								if (rowIndex !== -1) {
									this.$set(this.netlinks[rowIndex], "_isDuplicate", false);
									this.newRows.delete(rowIndex);
								}

								this.$vs.notify({
									title: "Succès",
									text: "Netlink en attente créé avec succès (URL sera complétée plus tard)",
									iconPack: "feather",
									icon: "check-circle",
									color: "success",
								});
							}
						} else {
							this.$vs.notify({
								title: "Erreur",
								text: "Une erreur est survenue lors de la création du netlink",
								iconPack: "feather",
								icon: "alert-circle",
								color: "danger",
							});
						}
					});
			}
		},
		async deleteNetlink(netlink) {
			// Confirm dialog
			if (!confirm("Êtes-vous sûr de vouloir supprimer ce netlink ?")) {
				return;
			}

			if (netlink.id) {
				try {
					// If it has an ID, we need to delete it from the server
					await Netlink.deleteAsync(netlink.id);
					const index = this.netlinks.findIndex((n) => n.id === netlink.id);
					if (index !== -1) {
						this.netlinks.splice(index, 1);
						this.deletedRows.delete(index);
						this.modifiedRows.delete(index);

						// Update row data in the grid directly
						if (this.gridApi) {
							this.gridApi.setRowData(this.netlinks);
						}

						this.tableKey++; // Force refresh
					}

					// ✅ NOUVEAU : Refresh global store after delete
					try {
						await store.dispatch("getAllNetlink");
						console.log("✅ Store refreshed after delete");
					} catch (storeError) {
						console.error(
							"❌ Error refreshing store after delete:",
							storeError
						);
					}

					this.$vs.notify({
						title: "Succès",
						text: "Netlink supprimé avec succès",
						iconPack: "feather",
						icon: "check-circle",
						color: "success",
					});
				} catch (err) {
					console.error(err);
					this.$vs.notify({
						title: "Erreur",
						text: "Une erreur est survenue lors de la suppression du netlink",
						iconPack: "feather",
						icon: "alert-circle",
						color: "danger",
					});
				}
			} else {
				// If it doesn't have an ID, we can just remove it from the UI
				const index = this.netlinks.findIndex((n) => n === netlink);
				if (index !== -1) {
					this.netlinks.splice(index, 1);
					this.newRows.delete(index);

					// Update row data in the grid directly
					if (this.gridApi) {
						this.gridApi.setRowData(this.netlinks);
					}

					this.tableKey++; // Force refresh
				}
			}
		},

		// ✅ FIXED: Update saveAllChanges method to use INDEX-BASED tracking
		saveAllChanges() {
			this.duplicationConfirmationPopup = false;
			this.isSaving = true;

			// Stop any active editing
			if (this.gridApi) {
				this.gridApi.stopEditing();
			}

			// ✅ CRITICAL FIX: Get all rows that will be saved using INDEX-BASED approach like Code 1
			// Modified rows are now tracked by netlink ID, not index
			const modifiedRowsData = Array.from(this.modifiedRows)
				.map((netlinkId) => {
					const netlink = this.netlinks.find((n) => n.id === netlinkId);
					if (netlink) {
						const index = this.netlinks.indexOf(netlink);
						return { data: netlink, index, isNew: false };
					}
					return null;
				})
				.filter((n) => n !== null);

			const newRowsData = Array.from(this.newRows)
				.map((index) => {
					if (index < this.netlinks.length) {
						return { data: this.netlinks[index], index, isNew: true };
					}
					return null;
				})
				.filter((n) => n !== null)
				// Filter only valid new rows
				.filter(({ data }) => this.isValidNetlink(data));

			// ✅ NOUVEAU : Filter duplicates and non-duplicates
			const nonDuplicateNewRows = newRowsData.filter(
				(e) => e.data._isDuplicate === false
			);
			const duplicateNewRows = newRowsData.filter(
				(e) => e.data._isDuplicate === true
			);

			console.log("Processing rows:", {
				modified: modifiedRowsData.length,
				newNonDuplicate: nonDuplicateNewRows.length,
				newDuplicate: duplicateNewRows.length,
			});

			const allRowsToSave = [
				...modifiedRowsData,
				...nonDuplicateNewRows,
				...duplicateNewRows,
			];

			// If no rows to save, show message and return
			if (allRowsToSave.length === 0) {
				this.isSaving = false;
				this.$vs.notify({
					title: "Information",
					text: "Aucune modification à enregistrer",
					iconPack: "feather",
					icon: "info",
					color: "primary",
				});
				return;
			}

			// Validate all rows - check for required fields
			const validationErrors = [];
			const requiredFields = [
				{ field: "contract_id", label: "N° Contrat" },
				{ field: "society_id", label: "Client" },
				{ field: "mission_id", label: "Prestation" },
				{ field: "period_date", label: "Période" },
				{ field: "url_bought", label: "URL backlinks" },
				{ field: "landing_page", label: "URL landing" },
				{ field: "provider_id", label: "Prestataire" },
				{ field: "link_type", label: "Type de lien" },
				{ field: "price", label: "Prix d'achat HT" },
			];

			allRowsToSave.forEach((rowInfo, rowNumber) => {
				const data = rowInfo.data;
				const missingFields = [];

				requiredFields.forEach(({ field, label }) => {
					const value = data[field];

					if (field === "provider_id" || field === "link_type") {
						if (
							value === null ||
							value === undefined ||
							value === "" ||
							value === "null"
						) {
							missingFields.push(label);
						}
					} else if (field === "price") {
						if (
							value === null ||
							value === undefined ||
							value === "" ||
							isNaN(value) ||
							Number(value) < 0
						) {
							missingFields.push(label);
						}
					} else if (
						field === "contract_id" ||
						field === "society_id" ||
						field === "mission_id"
					) {
						if (!value || value === "" || value === 0) {
							missingFields.push(label);
						}
					} else {
						if (!value || value === "") {
							missingFields.push(label);
						}
					}
				});

				if (missingFields.length > 0) {
					const rowType = rowInfo.isNew
						? "nouvelle ligne"
						: `ligne ${rowNumber + 1}`;
					validationErrors.push(`${rowType}: ${missingFields.join(", ")}`);
				}
			});

			if (validationErrors.length > 0) {
				this.isSaving = false;
				this.$vs.notify({
					title: "Champs obligatoires manquants",
					text: `Les champs suivants sont obligatoires:\n${validationErrors.join(
						"\n"
					)}`,
					iconPack: "feather",
					icon: "alert-circle",
					color: "danger",
					time: 8000,
				});
				return;
			}

			// Process existing rows (updates) - check for actual changes
			const modifiedNetlinks = modifiedRowsData
				.map((rowInfo) => {
					let netlinkToSave = { ...rowInfo.data };
					if (this.hasNetlinkChanged(netlinkToSave)) {
						netlinkToSave = this.prepareNetlinkForSave(netlinkToSave);
						return netlinkToSave;
					}
					return null;
				})
				.filter((n) => n !== null);

			const savePromises = modifiedNetlinks.map((netlink) => {
				delete netlink._isNew;
				delete netlink._isDuplicate;
				delete netlink._existingId;
				return Netlink.updateNetlink(netlink.id, netlink);
			});

			// ✅ NOUVEAU : Process duplicate new rows (updates to existing records)
			const duplicateNetlinks = duplicateNewRows
				.map((rowInfo) => {
					let netlinkToSave = { ...rowInfo.data };
					netlinkToSave = this.prepareNetlinkForSave(netlinkToSave);

					// ✅ CRITICAL: Use the existing ID for updates
					netlinkToSave.id = rowInfo.data._existingId;

					return netlinkToSave;
				})
				.filter((n) => n !== null);

			const editDuplicatePromises = duplicateNetlinks.map((netlink) => {
				delete netlink._isNew;
				delete netlink._isDuplicate;
				delete netlink._existingId;
				return Netlink.updateNetlink(netlink.id, netlink);
			});

			// Process non-duplicate new rows (creates)
			const newNetlinks = nonDuplicateNewRows
				.map((rowInfo) => {
					let netlinkToSave = { ...rowInfo.data };
					netlinkToSave = this.prepareNetlinkForSave(netlinkToSave);
					return netlinkToSave;
				})
				.filter((n) => n !== null);

			const createPromises = newNetlinks.map((netlink) => {
				delete netlink._isNew;
				delete netlink._isDuplicate;
				delete netlink._existingId;
				return Netlink.createNetlink(netlink);
			});

			// ✅ NOUVEAU : Include all promises in the execution
			const allPromises = [
				...savePromises,
				...editDuplicatePromises,
				...createPromises,
			];

			if (allPromises.length === 0) {
				this.isSaving = false;
				this.$vs.notify({
					title: "Information",
					text: "Aucune modification à enregistrer",
					iconPack: "feather",
					icon: "info",
					color: "primary",
				});
				this.resetChangeTracking();
				return;
			}

			// Execute all promises
			Promise.all(allPromises)
				.then(async (results) => {
					// Handle results for new records (assigns new IDs)
					const createStartIndex =
						savePromises.length + editDuplicatePromises.length;
					results.forEach((result, index) => {
						if (result && result.id && index >= createStartIndex) {
							// This is a newly created record
							const newRowIndex = Array.from(this.newRows)[
								index - createStartIndex
							];
							if (
								newRowIndex !== undefined &&
								newRowIndex < this.netlinks.length
							) {
								const updatedNetlink = {
									...this.netlinks[newRowIndex],
									id: result.id,
									_isNew: false,
									_isDuplicate: false,
								};
								delete updatedNetlink._existingId;

								this.originalNetlinks[result.id] = JSON.parse(
									JSON.stringify(updatedNetlink)
								);
								this.$set(this.netlinks, newRowIndex, updatedNetlink);
							}
						}
					});

					// Update original data for all modified records
					[...modifiedNetlinks, ...duplicateNetlinks].forEach((netlink) => {
						if (netlink.id) {
							this.originalNetlinks[netlink.id] = JSON.parse(
								JSON.stringify(netlink)
							);
						}
					});

					// ✅ NOUVEAU : Refresh global store after successful saves
					try {
						console.log("🔄 Refreshing global store after save...");
						await store.dispatch("getAllNetlink");
						console.log("✅ Global store refreshed successfully");
					} catch (storeError) {
						console.error("❌ Error refreshing store:", storeError);
					}

					this.$vs.notify({
						title: "Succès",
						text: `Modifications enregistrées (${savePromises.length} mises à jour, ${editDuplicatePromises.length} doublons mis à jour, ${createPromises.length} créations)`,
						iconPack: "feather",
						icon: "check-circle",
						color: "success",
					});

					// Reset tracking and close popup
					this.resetChangeTracking();
					this.duplicationConfirmationPopup = false;
					this.isSaving = false;
				})
				.catch((err) => {
					console.error("Save error:", err);
					this.isSaving = false;
					this.$vs.notify({
						title: "Erreur",
						text:
							"Une erreur est survenue lors de l'enregistrement des modifications. Détails: " +
							(err.message || "Erreur inconnue"),
						iconPack: "feather",
						icon: "alert-circle",
						color: "danger",
						time: 5000,
					});
				});
		},
		onBtStopEditing() {
			if (this.gridApi) {
				this.gridApi.stopEditing();
			}
		},
		onBtStartEditing() {
			if (this.netlinks.length > 1 && this.gridApi) {
				this.gridApi.setFocusedCell(1, "provider_id");
				this.gridApi.startEditingCell({
					rowIndex: 1,
					colKey: "provider_id",
				});
			}
		},
		onGridReady(params) {
			this.gridApi = params.api;
			// Debug information
			console.log("Grid ready with data:", {
				providers: this.providers.length,
				linkTypes: this.linkTypes.length,
				netlinkStatus: this.netlinkStatus.length,
				anchorTypes: this.anchorTypes.length,
			});
		},
		onSelectionChanged() {
			if (!this.gridApi) return;

			const selectedNodes = this.gridApi.getSelectedNodes();
			this.selectedRows.clear();
			this.selectedRowsData = [];

			selectedNodes.forEach((node) => {
				if (node.data) {
					this.selectedRows.add(node.data.id || node.id);
					this.selectedRowsData.push(node.data);
				}
			});
		},

		async exportNetlinks() {
			try {
				this.isExporting = true;

				// Show initial notification
				this.$vs.notify({
					title: "Export en cours",
					text: "Préparation de l'export des netlinks...",
					iconPack: "feather",
					icon: "download-cloud",
					color: "primary",
				});

				// Get all netlinks without pagination by setting a very high page number or using a special parameter
				const exportQueries = { ...this.queries };

				// Call the API to get all filtered data without pagination
				const allNetlinksResult = await this.getFilteredNetlinksForExport(
					exportQueries
				);

				if (!allNetlinksResult || allNetlinksResult.length === 0) {
					this.$vs.notify({
						title: "Aucune donnée",
						text: "Aucun netlink ne correspond aux filtres actuels",
						iconPack: "feather",
						icon: "info",
						color: "warning",
					});
					return;
				}

				// Process and format the data for export
				const exportData = this.prepareDataForExport(allNetlinksResult);

				// Generate and download CSV file
				this.downloadCSV(exportData, this.generateExportFilename());

				this.$vs.notify({
					title: "Export réussi",
					text: `${allNetlinksResult.length} netlinks exportés avec succès`,
					iconPack: "feather",
					icon: "check-circle",
					color: "success",
				});
			} catch (error) {
				console.error("Export error:", error);
				this.$vs.notify({
					title: "Erreur d'export",
					text: "Une erreur est survenue lors de l'export des netlinks",
					iconPack: "feather",
					icon: "alert-circle",
					color: "danger",
				});
			} finally {
				this.isExporting = false;
			}
		},
		async getFilteredNetlinksForExport(queries) {
			try {
				// You might need to modify your API call or create a new endpoint that returns all data
				// Option 1: If your API supports a 'limit=0' or 'all=true' parameter
				// const result = await Netlink.getFilteredNetlinks(queries, 1, { exportAll: true });
				// return result.data || result;

				// Option 2: If you need to make multiple API calls to get all pages
				const allNetlinks = [];
				let currentPage = 1;
				let hasMoreData = true;

				while (hasMoreData) {
					const result = await Netlink.getFilteredNetlinks(
						queries,
						currentPage
					);
					if (result.data && result.data.length > 0) {
						allNetlinks.push(...result.data);
						currentPage++;
						// Check if we've reached the last page
						hasMoreData = currentPage <= result.pagination.totalPages;
					} else {
						hasMoreData = false;
					}
				}
				return allNetlinks;
			} catch (error) {
				console.error("Error fetching export data:", error);
				throw error;
			}
		},
		// 🔹 NEW: Prepare data for export
		prepareDataForExport(netlinks) {
			return netlinks.map((netlink) => {
				// Get formatted values using the same logic as the grid with proper error handling
				const society = this.societies.find(
					(s) => s.id === parseInt(netlink.society_id)
				);
				const societyName = society ? society.name : "";

				const contractStatus = this.getContractStatus(netlink.contract_status);

				const mission = this.missions.find(
					(m) => m.id === parseInt(netlink.mission_id)
				);
				const missionName = mission ? mission.perform : "";

				const provider = this.providers.find(
					(p) => p.id === parseInt(netlink.provider_id)
				);
				const providerName = provider ? provider.society : "";

				const linkType = this.linkTypes.find(
					(t) => t.id === parseInt(netlink.link_type)
				);
				const linkTypeName = linkType ? linkType.name : "";

				const thema = this.themas.find(
					(t) => t.id === parseInt(netlink.thema_id || 0)
				);
				const themaName = thema ? thema.name : "";

				const anchorType = this.anchorTypes.find(
					(t) => t.type_value === (netlink.anchor_type || 0)
				);
				const anchorTypeName = anchorType ? anchorType.type_text : "";

				const status = this.netlinkStatus.find(
					(s) => s.status_value == netlink.status
				);
				const statusText = status ? status.status_text : "";

				const contract = this.contracts.find(
					(c) => c.id === parseInt(netlink.contract_id)
				);
				const consultantName =
					contract && contract.manager_name ? contract.manager_name : "";

				const renewDuration = this.renewDurations.find(
					(d) => d.id === Number(netlink.renew_duration)
				);
				const renewLabel = renewDuration ? renewDuration.label : "";

				// Calculate sale price and margin
				const salePrice =
					netlink.calculated_price ||
					this.calculateSalePrice(netlink.price, netlink.mission_id);
				const marginPercentage = this.calculateMarginPercentage(
					netlink.price,
					salePrice
				);

				return {
					ID: netlink.id || "",
					Statut: statusText,
					"En ligne": netlink.additional_online_status || "",
					"Etat du lien": netlink.additional_link_type || "",
					Client: societyName,
					"N° Contrat": netlink.contract_id || "",
					"Statut Contrat": contractStatus,
					Prestation: missionName,
					Consultant: consultantName,
					Période:
						this.formatPeriod(netlink.period_date) || netlink.period_date || "",
					"URL Backlinks": netlink.url_bought || "",
					"URL Landing": netlink.landing_page || "",
					Prestataire: providerName,
					"Type de lien": linkTypeName,
					Thématique: themaName,
					"Type d'ancre": anchorTypeName,
					Ancre: netlink.anchor || "",
					International: netlink.is_international ? "Oui" : "Non",
					Renew: renewLabel,
					"Date de renew": this.formatTimeStamp(netlink.renew_date),
					// Facturable: netlink.is_billable ? "Oui" : "Non",
					"Prix d'achat HT": netlink.price ? `${netlink.price} €` : "",
					"Prix de vente HT": salePrice ? `${salePrice} €` : "",
					"Taux Marge": marginPercentage,
					"Date création": this.formatTimeStamp(netlink.creation_date),
				};
			});
		},

		// 🔹 NEW: Generate export filename
		generateExportFilename() {
			const now = new Date();
			const dateStr = now.toISOString().split("T")[0]; // YYYY-MM-DD
			const timeStr = now.toTimeString().split(" ")[0].replace(/:/g, "-"); // HH-MM-SS

			// Add filter info to filename if any filters are applied
			let filterInfo = "";
			if (this.queries.contract_id)
				filterInfo += `_contrat-${this.queries.contract_id}`;
			if (this.queries.society_id)
				filterInfo += `_client-${this.queries.society_id}`;

			// Period range in filename
			if (this.queries.period && this.queries.end_period_date) {
				filterInfo += `_periode-${this.queries.period.replace(
					"/",
					"-"
				)}_au_${this.queries.end_period_date.replace("/", "-")}`;
			} else if (this.queries.period) {
				filterInfo += `_periode-${this.queries.period.replace("/", "-")}`;
			}

			return `netlinks_export${filterInfo}_${dateStr}_${timeStr}.csv`;
		},

		// 🔹 NEW: Download CSV file
		downloadCSV(data, filename) {
			if (!data || data.length === 0) {
				throw new Error("No data to export");
			}

			// Get headers from first row
			const headers = Object.keys(data[0]);

			// Create CSV content
			const csvContent = [
				// Headers row
				headers.map((header) => `"${header}"`).join(","),
				// Data rows
				...data.map((row) =>
					headers
						.map((header) => {
							const value = row[header] || "";
							// Escape quotes and wrap in quotes
							return `"${String(value).replace(/"/g, '""')}"`;
						})
						.join(",")
				),
			].join("\n");

			// Create blob and download
			const blob = new Blob(["\ufeff" + csvContent], {
				type: "text/csv;charset=utf-8;",
			}); // \ufeff is BOM for UTF-8

			const link = document.createElement("a");
			const url = URL.createObjectURL(blob);

			link.setAttribute("href", url);
			link.setAttribute("download", filename);
			link.style.visibility = "hidden";

			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);

			// Clean up
			URL.revokeObjectURL(url);
		},
	},
};
</script>
<style scoped>
.filter-pending-indicator {
	display: flex;
	align-items: center;
	padding: 8px 12px;
	background-color: #fff3cd;
	border: 1px solid #ffc107;
	border-radius: 4px;
	margin-top: 10px;
	margin-bottom: 10px;
	color: #856404;
	font-size: 14px;
}

.spin-animation {
	animation: spin 1s linear infinite;
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}

.price-totals {
	display: inline-flex;
	align-items: center;
	gap: 12px;
	padding: 8px 16px;
	background-color: #f0f9ff;
	border-radius: 6px;
	border: 1px solid #08b0b9;
	margin-right: 8px;
}

.total-item {
	font-size: 14px;
	color: #333;
}

.total-item strong {
	color: #08b0b9;
	margin-right: 4px;
}

.divider {
	color: #ccc;
	font-weight: 300;
}

.example-wrapper {
	display: flex;
	flex-direction: column;
	height: 100%;
}

.button-container {
	display: flex;
	gap: 10px;
	margin-bottom: 10px;
}

.action-button {
	padding: 8px 16px;
	border: 1px solid #ccc;
	border-radius: 4px;
	background-color: #f8f8f8;
	cursor: pointer;
	font-size: 14px;
	transition: all 0.2s;
}

:hover {
	background-color: #45a049;
}

button {
	margin-right: 10px;
	padding: 5px 10px;
	border: 1px solid #ccc;
	border-radius: 4px;
	background-color: #f8f8f8;
	cursor: pointer;
}

button:hover {
	background-color: #e8e8e8;
}

.action-buttons {
	display: flex;
	gap: 5px;
}

.btn-icon {
	width: 30px;
	height: 30px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	border: none;
	cursor: pointer;
}

.btn-save {
	background-color: #4caf50;
	color: white;
}

.btn-delete {
	background-color: #f44336;
	color: white;
}

.btn-clear {
	background-color: #ff9800;
	color: white;
}

/* New filter styles */
.filter-section {
	margin-bottom: 15px;
	padding: 10px;
	background-color: #f9f9f9;
	border-radius: 5px;
	border: 1px solid #eee;
}

.filter-section h4 {
	margin-top: 0;
	margin-bottom: 10px;
	color: #333;
}

.filter-row {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	margin-bottom: 10px;
}

.filter-item {
	flex: 1;
	max-width: 250px;
}

.filter-item label {
	display: block;
	margin-bottom: 5px;
	font-size: 14px;
	color: #666;
}

.filter-item input,
.filter-item select {
	width: 100%;
	padding: 8px;
	border: 1px solid #ddd;
	border-radius: 4px;
	font-size: 14px;
}

.filter-item input:focus,
.filter-item select:focus {
	border-color: #1976d2;
	outline: none;
}

.flex-row {
	display: flex;
	gap: 10px;
}

.mt-2 {
	margin-top: 10px;
}

.loader-container {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 200px;
}

/* Toggle checkbox styling */
.filter-item label small {
	display: inline-flex;
	align-items: center;
	gap: 4px;
}

.filter-item label small input[type="checkbox"] {
	margin: 0;
	transform: scale(0.8);
}

/* Clear button for month picker */
.period-picker-container::after {
	cursor: pointer;
}

.period-picker-container:hover::after {
	display: block;
}

@media (max-width: 768px) {
	.filter-item {
		min-width: 100%;
	}
}

.status-change-popup .popup-content {
	text-align: center;
	padding: 20px;
}

.status-change-popup .warning-icon {
	margin-bottom: 20px;
}

.status-change-popup h3 {
	color: #333;
	margin-bottom: 15px;
	font-size: 18px;
}

.status-change-popup p {
	color: #666;
	margin-bottom: 25px;
	font-size: 16px;
}

.status-change-popup .popup-actions {
	display: flex;
	gap: 10px;
	justify-content: center;
	flex-wrap: wrap;
}
</style>
